export interface Input {
  criteria: number;
  button: number;
  multi: number;
  square: boolean;
  combo: boolean;
  combotype: number;
  extracrit: number;
}

export interface Separator {
  index: number;
  msg?: string;
  img?: number;
}

export interface Game {
  name: string;
  image: number;
  critname: string[];
  critweight: number[];
  inputs: Input[];
  separators?: Separator[];
}

const inD: Input = {
  criteria: 0,
  button: 1,
  multi: 1,
  square: false,
  combo: false,
  combotype: 0,
  extracrit: -1,
};

function fillPair(
  a: Input,
  afill: number,
  b: Input,
  bfill: number,
  n: number,
): Input[] {
  const array: Input[] = [];
  for (let i = 0; i < n * 2; i++) {
    if (i % 2 === 0) {
      array.push(...Array(afill).fill(a));
    } else {
      array.push(...Array(bfill).fill(b));
    }
  }
  return array;
}

function combo(arr: Input[]): Input[] {
  arr.forEach((i: Input) => {
    i.combo = true;
  });
  arr[0].combotype = 1;
  arr[arr.length - 1].combotype = 2;
  return arr;
}

export const gameData: Game[] = [
  { // Karate Man
    name: "Karate Man",
    image: 0,
    critname: ["Single Punch", "Triple Punch"],
    critweight: [65, 25, 10],
    inputs: [
      ...Array(13).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2 },
      { ...inD, criteria: 0 },
      ...Array(3).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0 },
    ],
    separators: [{ index: 7 }],
  },
  { // Fillbots
    name: "Fillbots",
    image: 1,
    critname: ["Normal", "Large"],
    critweight: [70, 12, 18],
    inputs: [
      ...Array(5).fill(
        combo([
          { ...inD, criteria: 0, button: 4, square: true },
          { ...inD, criteria: 0, button: 5, square: true },
        ]),
      ).flat(),
      ...combo([
        { ...inD, criteria: 2, button: 4, square: true },
        { ...inD, criteria: 2, button: 5, square: true },
      ]),
      ...Array(2).fill(
        combo([
          { ...inD, criteria: 0, button: 4, square: true },
          { ...inD, criteria: 0, button: 5, square: true },
        ]),
      ).flat(),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
    ],
  },
  { // Air Rally
    name: "Air Rally",
    image: 2,
    critname: ["Normal Shot", "Long Shot"],
    critweight: [70, 20, 10],
    inputs: [
      ...Array(14).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 1 },
        1,
        { ...inD, criteria: 0 },
        6,
        2,
      ),
      { ...inD, criteria: 2 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
    ],
  },
  { // Catchy Tune
    name: "Catchy Tune",
    image: 3,
    critname: ["Orange", "Pineapple"],
    critweight: [40, 45, 15],
    inputs: [
      ...fillPair(
        { ...inD, criteria: 0, button: 3 },
        1,
        { ...inD, criteria: 0, button: 1 },
        1,
        4,
      ),
      { ...inD, criteria: 1, button: 3 },
      { ...inD, criteria: 1, button: 1 },
      { ...inD, criteria: 0, button: 3 },
      { ...inD, criteria: 0, button: 1 },
      { ...inD, criteria: 2, button: 3 },
      { ...inD, criteria: 2, button: 1 },
      ...fillPair(
        { ...inD, criteria: 1, button: 3 },
        1,
        { ...inD, criteria: 1, button: 1 },
        1,
        2,
      ),
      ...fillPair(
        { ...inD, criteria: 1, button: 1 },
        1,
        { ...inD, criteria: 1, button: 3 },
        1,
        2,
      ),
      { ...inD, criteria: 0, button: 1 },
      { ...inD, criteria: 0, button: 3 },
      { ...inD, criteria: 1, button: 3 },
      { ...inD, criteria: 1, button: 1 },
    ],
  },
  { // Rhythm Tweezers
    name: "Rhythm Tweezers",
    image: 4,
    critname: ["Short Hair"],
    critweight: [85, 15],
    inputs: [
      ...Array(39).fill({ ...inD, criteria: 0 }),
      ...Array(4).fill({ ...inD, criteria: 1 }),
      ...Array(7).fill({ ...inD, criteria: 0 }),
    ],
    separators: [
      { index: 4 },
      { index: 8 },
      { index: 13 },
      { index: 18 },
      { index: 24 },
      { index: 28 },
      { index: 33 },
      { index: 39 },
      { index: 43 },
    ],
  },
  { // Glee Club
    name: "Glee Club",
    image: 5,
    critname: ["Open", "Close"],
    critweight: [35, 40, 25],
    inputs: [
      ...fillPair(
        { ...inD, criteria: 0, button: 5 },
        1,
        { ...inD, criteria: 1, button: 4 },
        1,
        4,
      ),
      { ...inD, criteria: 2, button: 5 },
      { ...inD, criteria: 2, button: 4, multi: 0 },
      { ...inD, criteria: 2, button: 5 },
      { ...inD, criteria: 2, button: 4 },
      ...fillPair(
        { ...inD, criteria: 0, button: 5 },
        1,
        { ...inD, criteria: 1, button: 4 },
        1,
        2,
      ),
    ],
  },
  { // Figure Fighter
    name: "Figure Fighter",
    image: 6,
    critname: ["Single Punch", "Double Punch"],
    critweight: [25, 60, 15],
    inputs: [
      ...fillPair(
        { ...inD, criteria: 1 },
        4,
        { ...inD, criteria: 0 },
        1,
        2,
      ),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(6).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
    ],
  },
  { // Fruit Basket
    name: "Fruit Basket",
    image: 7,
    critname: ["Apple", "Lemon"],
    critweight: [60, 16, 24],
    inputs: [
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 0, multi: 2 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 0, multi: 2 },
      { ...inD, criteria: 2, multi: 2 },
    ],
    separators: [{ index: 9 }],
  },
  { // The Clappy Trio
    name: "The Clappy Trio",
    image: 8,
    critname: ["Main", "Fast"],
    critweight: [50, 35, 15],
    inputs: [
      ...Array(5).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 2 },
    ],
  },
  { // Shoot-'em-up
    name: "Shoot-'em-up",
    image: 9,
    critname: ["Main", "Fast"],
    critweight: [45, 45, 10],
    inputs: [
      ...Array(17).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      ...Array(14).fill({ ...inD, criteria: 0 }),
      ...Array(20).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
    ],
    separators: [
      { index: 2 },
      { index: 4 },
      { index: 6 },
      { index: 8 },
      { index: 11 },
      { index: 14 },
      { index: 17 },
      { index: 19 },
      { index: 23 },
      { index: 27 },
      { index: 31 },
      { index: 33 },
      { index: 38 },
      { index: 43 },
      { index: 48 },
      { index: 53 },
    ],
  },
  { // Micro-Row
    name: "Micro-Row",
    image: 10,
    critname: ["Single March", "Triple March"],
    critweight: [45, 45, 10],
    inputs: [
      ...Array(12).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        6,
        { ...inD, criteria: 1 },
        3,
        3,
      ),
      ...fillPair(
        { ...inD, criteria: 0 },
        2,
        { ...inD, criteria: 1 },
        3,
        2,
      ),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 2 }),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(6).fill({ ...inD, criteria: 1 }),
    ],
  },
  { // First Contact
    name: "First Contact",
    image: 11,
    critname: ["Main", "Pause", "Pork Rice Bowls"],
    critweight: [60, 15, 15, 10],
    inputs: [
      ...combo(
        Array.from(
          { length: 4 },
          () => ({ ...inD, criteria: 0 }),
        ),
      ),
      ...combo(Array.from({ length: 4 }, () => ({ ...inD, criteria: 0 }))),
      ...combo(Array.from({ length: 4 }, () => ({ ...inD, criteria: 0 }))),
      { ...inD, criteria: 1 },
      ...combo(Array.from({ length: 5 }, () => ({ ...inD, criteria: 0 }))),
      ...combo(Array.from({ length: 4 }, () => ({ ...inD, criteria: 0 }))),
      ...combo(Array.from({ length: 3 }, () => ({ ...inD, criteria: 0 }))),
      { ...inD, criteria: 3 },
      ...combo(Array.from({ length: 2 }, () => ({ ...inD, criteria: 0 }))),
      ...combo(Array.from({ length: 5 }, () => ({ ...inD, criteria: 0 }))),
      ...combo(Array.from({ length: 2 }, () => ({ ...inD, criteria: 0 }))),
      ...combo(Array.from({ length: 5 }, () => ({ ...inD, criteria: 2 }))),
      ...combo(Array.from({ length: 4 }, () => ({ ...inD, criteria: 0 }))),
      ...combo(Array.from({ length: 3 }, () => ({ ...inD, criteria: 0 }))),
      ...combo(Array.from({ length: 2 }, () => ({ ...inD, criteria: 0 }))),
      ...combo(Array.from({ length: 5 }, () => ({ ...inD, criteria: 0 }))),
      { ...inD, criteria: 1 },
    ],
    separators: [
      { index: 4 },
      { index: 8 },
      { index: 12 },
      { index: 13 },
      { index: 18 },
      { index: 22 },
      { index: 25 },
      { index: 26 },
      { index: 28 },
      { index: 33 },
      { index: 35 },
      { index: 40 },
      { index: 44 },
      { index: 47 },
      { index: 49 },
      { index: 54 },
    ],
  },
  { // Bunny Hop
    name: "Bunny Hop",
    image: 12,
    critname: ["Main", "Rest"],
    critweight: [70, 20, 10],
    inputs: [
      ...Array(37).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
      ...Array(20).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
      ...Array(12).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
      ...Array(23).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
      ...Array(8).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2 },
      ...Array(12).fill({ ...inD, criteria: 0 }),
    ],
    separators: [
      { index: 37, msg: "4-rest" },
      { index: 58, msg: "4-rest" },
      { index: 71, msg: "4-rest" },
      { index: 78, msg: "2-rest" },
      { index: 95, msg: "8-rest" },
      { index: 104, msg: "8-rest" },
      { index: 111, msg: "2-rest" },
    ],
  },
  { // Airboarder
    name: "Airboarder",
    image: 13,
    critname: ["Duck", "Jump"],
    critweight: [60, 26, 14],
    inputs: [
      ...Array(4).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 0, button: 4 },
      { ...inD, criteria: 1, button: 5 },
      { ...inD, criteria: 0 },
      { ...inD, criteria: 0, button: 4 },
      { ...inD, criteria: 1, button: 5 },
      ...Array(4).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2, button: 4 },
      { ...inD, criteria: 2, button: 5 },
      ...Array(3).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 0, button: 4 },
        1,
        { ...inD, criteria: 1, button: 5 },
        1,
        2,
      ),
      { ...inD, criteria: 0 },
      { ...inD, criteria: 0, button: 4 },
      { ...inD, criteria: 1, button: 5 },
    ],
  },
  { // Exhibition Match
    name: "Exhibition Match",
    image: 14,
    critname: ["Main", "Silent"],
    critweight: [60, 20, 20],
    inputs: [
      ...Array(9).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2 },
      { ...inD, criteria: 1 },
      { ...inD, criteria: 0 },
    ],
  },
  { // Tongue Lashing
    name: "Tongue Lashing",
    image: 15,
    critname: ["Yellow Bug", "Red Bug", "Many Bugs"],
    critweight: [40, 30, 20, 10],
    inputs: [
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 0, multi: 2 }),
      { ...inD, criteria: 1 },
      ...Array(9).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 0, multi: 2 },
      { ...inD, criteria: 0 },
      { ...inD, criteria: 0, multi: 2 },
      { ...inD, criteria: 3 },
      ...Array(2).fill({ ...inD, criteria: 2, multi: 4 }),
      { ...inD, criteria: 1 },
      ...Array(3).fill({ ...inD, criteria: 2, multi: 4 }),
      ...Array(2).fill({ ...inD, criteria: 0, multi: 2 }),
      { ...inD, criteria: 0 },
      { ...inD, criteria: 2, multi: 20 },
      { ...inD, criteria: 1 },
      { ...inD, criteria: 1, multi: 4 },
      ...Array(2).fill({ ...inD, criteria: 2, multi: 14 }),
    ],
    separators: [
      { index: 9 },
      { index: 11 },
      { index: 13 },
      { index: 15 },
      { index: 17 },
      { index: 20 },
      { index: 21 },
      { index: 22 },
      { index: 23 },
      { index: 27 },
      { index: 29 },
      { index: 31 },
    ],
  },
  { // Sneaky Spirits
    name: "Sneaky Spirits",
    image: 16,
    critname: ["Main", "Slow"],
    critweight: [50, 30, 20],
    inputs: [
      ...Array(3).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
      { ...inD, criteria: 0 },
      { ...inD, criteria: 2 },
      { ...inD, criteria: 1 },
      { ...inD, criteria: 0 },
    ],
  },
  { // Rhythm Rally
    name: "Rhythm Rally",
    image: 17,
    critname: ["Normal Swing", "Long Swing"],
    critweight: [70, 16, 14],
    inputs: [
      { ...inD, criteria: 1 },
      ...Array(8).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
      { ...inD, criteria: 2 },
      ...Array(8).fill({ ...inD, criteria: 0 }),
    ],
  },
  { // Flipper-Flop
    name: "Flipper-Flop",
    image: 18,
    critname: ["Flip", "Flipper-Roll"],
    critweight: [60, 30, 10],
    inputs: [
      ...fillPair(
        { ...inD, criteria: 0 },
        15,
        { ...inD, criteria: 1, button: 2 },
        1,
        2,
      ),
      ...Array(14).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1, button: 2 }),
      ...Array(14).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 2, button: 2 }),
      ...Array(7).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 2 },
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1, button: 2 }),
      ...Array(7).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 2 },
      ...fillPair(
        { ...inD, criteria: 0 },
        6,
        { ...inD, criteria: 1, button: 2 },
        2,
        2,
      ),
    ],
  },
  { // LumBEARjack
    name: "LumBEARjack",
    image: 19,
    critname: ["Log", "Big Log", "Not a Log", "Cat Dance"],
    critweight: [25, 26, 10, 25, 14],
    inputs: [
      ...Array(5).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 1, square: true },
        { ...inD, criteria: 1, square: true },
      ]),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2 },
      ...Array(3).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 4, square: true },
        { ...inD, criteria: 4, square: true },
      ]),
      ...Array(3).fill({ ...inD, criteria: 3 }),
      ...combo([
        { ...inD, criteria: 1, square: true },
        { ...inD, criteria: 1, square: true },
      ]),
      { ...inD, criteria: 3 },
      ...combo([
        { ...inD, criteria: 1, square: true },
        { ...inD, criteria: 1, square: true },
      ]),
      { ...inD, criteria: 3 },
      ...combo([
        { ...inD, criteria: 1, square: true },
        { ...inD, criteria: 1, square: true },
      ]),
    ],
    separators: [
      { index: 18 },
    ],
  },
  { // Power Calligraphy
    name: "Power Calligraphy",
    image: 20,
    critname: ["Main", "Chikara", "Kokoro", "Face"],
    critweight: [30, 25, 25, 10, 10],
    inputs: [
      ...fillPair(
        { ...inD, criteria: 0 },
        3,
        { ...inD, criteria: 1 },
        1,
        2,
      ),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0 },
      ...Array(2).fill({ ...inD, criteria: 4 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0 },
      ...Array(2).fill({ ...inD, criteria: 2 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
      ...Array(2).fill({ ...inD, criteria: 2 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
      ...Array(2).fill({ ...inD, criteria: 2 }),
      { ...inD, criteria: 3 },
    ],
  },
  { // Blue Birds
    name: "Blue Birds",
    image: 21,
    critname: ["Peck", "Stretch"],
    critweight: [55, 32, 13],
    inputs: [
      { ...inD, criteria: 1, button: 4 },
      { ...inD, criteria: 1, button: 5 },
      ...Array(33).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 4 },
      { ...inD, criteria: 1, button: 5 },
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 4 },
      { ...inD, criteria: 1, button: 5 },
      { ...inD, criteria: 1, button: 4 },
      { ...inD, criteria: 1, button: 5 },
      { ...inD, criteria: 2, button: 4 },
      { ...inD, criteria: 2, button: 5 },
    ],
    separators: [
      { index: 14 },
      { index: 23 },
      { index: 32 },
      { index: 37 },
      { index: 43 },
    ],
  },
  { // Flock Step
    name: "Flock Step",
    image: 22,
    critname: ["Stomp", "Jump"],
    critweight: [40, 52, 8],
    inputs: [
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(14).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(14).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(10).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      { ...inD, criteria: 2, button: 6 },
      { ...inD, criteria: 2, button: 7 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(14).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(24).fill({ ...inD, criteria: 0 }),
    ],
    separators: [
      { index: 32 },
      { index: 80 },
      { index: 128 },
      { index: 160 },
      { index: 192 },
      { index: 200 },
      { index: 232 },
    ],
  },
  { // Super Samurai Slice
    name: "Super Samurai Slice",
    image: 23,
    critname: ["Normal", "Many", "Boss"],
    critweight: [42, 12, 30, 16],
    inputs: [
      ...Array(10).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 2, button: 6 },
        { ...inD, criteria: 2, button: 7 },
      ]),
      ...Array(9).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 3, button: 6 },
        { ...inD, criteria: 3, button: 7 },
      ]),
      ...Array(8).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 2, button: 6 },
        { ...inD, criteria: 2, button: 7 },
      ]),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0 },
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 2, button: 6 },
        { ...inD, criteria: 2, button: 7 },
      ]),
    ],
  },
  { // Spaceball
    name: "Spaceball",
    image: 24,
    critname: ["Normal Shot", "High Shot"],
    critweight: [55, 35, 10],
    inputs: [
      ...Array(5).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        6,
        { ...inD, criteria: 1 },
        1,
        2,
      ),
      ...fillPair(
        { ...inD, criteria: 0 },
        2,
        { ...inD, criteria: 1 },
        1,
        2,
      ),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2 },
      ...fillPair(
        { ...inD, criteria: 0 },
        6,
        { ...inD, criteria: 1 },
        1,
        3,
      ),
      { ...inD, criteria: 1 },
    ],
  },
  { // Dog Ninja
    name: "Dog Ninja",
    image: 25,
    critname: ["Single Slice", "Double Slice"],
    critweight: [52, 40, 8],
    inputs: [
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        6,
        { ...inD, criteria: 1 },
        1,
        2,
      ),
      ...fillPair(
        { ...inD, criteria: 0 },
        10,
        { ...inD, criteria: 1 },
        1,
        2,
      ),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
      ...Array(8).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2 },
      ...fillPair(
        { ...inD, criteria: 0 },
        6,
        { ...inD, criteria: 1 },
        2,
        2,
      ),
    ],
  },
  { // Hole in One
    name: "Hole in One",
    image: 26,
    critname: ["Monkey", "Mandrill"],
    critweight: [60, 30, 10],
    inputs: [
      ...Array(17).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
      ...Array(14).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2 },
      ...Array(12).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        2,
        { ...inD, criteria: 1 },
        1,
        3,
      ),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        1,
        { ...inD, criteria: 1 },
        1,
        2,
      ),
    ],
  },
  { // Sumo Brothers
    name: "Sumo Brothers",
    image: 27,
    critname: ["Slap", "Stomp", "Pose"],
    critweight: [35, 35, 20, 10],
    inputs: [
      ...fillPair(
        { ...inD, criteria: 1 },
        8,
        { ...inD, criteria: 0 },
        8,
        2,
      ),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2, button: 2 },
      { ...inD, criteria: 3, button: 2 },
      ...Array(16).fill({ ...inD, criteria: 0 }),
      ...Array(6).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 2, button: 2 },
      ...Array(16).fill({ ...inD, criteria: 0 }),
      ...Array(6).fill({ ...inD, criteria: 1 }),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2, button: 2 },
    ],
  },
  { // Lush Remix
    name: "Lush Remix",
    image: 28,
    critname: ["Normal", "Keep"],
    critweight: [46, 44, 10],
    inputs: [
      ...Array(21).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 2 },
      ...Array(13).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2, button: 2 },
      ...Array(12).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 1, button: 2 },
      ...Array(5).fill({ ...inD, criteria: 0 }),
      ...Array(6).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 1, button: 2 },
      ...Array(5).fill({ ...inD, criteria: 0 }),
    ],
    separators: [
      { index: 0, img: 24 },
      { index: 5, img: 25 },
      { index: 11, img: 24 },
      { index: 15, img: 25 },
      { index: 21, img: 27 },
      { index: 22, img: 26 },
      { index: 24, img: 24 },
      { index: 26, img: 26 },
      { index: 28, img: 24 },
      { index: 30, img: 25 },
      { index: 35, img: 27 },
      { index: 49, img: 24 },
      { index: 54, img: 27 },
      { index: 61, img: 26 },
      { index: 65, img: 24 },
    ],
  },
  { // Karate Man Returns!
    name: "Karate Man Returns!",
    image: 29,
    critname: ["Single Punch", "Triple Punch"],
    critweight: [65, 25, 10],
    inputs: [
      ...Array(9).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        10,
        { ...inD, criteria: 1 },
        3,
        2,
      ),
      { ...inD, criteria: 2 },
    ],
    separators: [
      { index: 6 },
      { index: 14 },
    ],
  },
  { // Fillbots 2
    name: "Fillbots 2",
    image: 30,
    critname: ["Normal", "Large"],
    critweight: [65, 15, 20],
    inputs: [
      ...Array(5).fill(
        combo([
          { ...inD, criteria: 0, button: 4, square: true },
          { ...inD, criteria: 0, button: 5, square: true },
        ]),
      ).flat(),
      ...combo([
        { ...inD, criteria: 2, button: 4, square: true },
        { ...inD, criteria: 2, button: 5, square: true },
      ]),
      ...Array(9).fill(
        combo([
          { ...inD, criteria: 0, button: 4, square: true },
          { ...inD, criteria: 0, button: 5, square: true },
        ]),
      ).flat(),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
    ],
    separators: [
      { index: 20 },
      { index: 26 },
    ],
  },
  { // Air Rally 2
    name: "Air Rally 2",
    image: 31,
    critname: ["Normal Shot", "Far Shot", "Long Shot"],
    critweight: [44, 20, 30, 6],
    inputs: [
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2 },
      ...Array(16).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 2 },
        1,
        { ...inD, criteria: 0 },
        2,
        3,
      ),
      { ...inD, criteria: 0 },
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(5).fill({ ...inD, criteria: 2 }),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 2 },
      ...Array(8).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 2 },
        1,
        { ...inD, criteria: 0 },
        2,
        2,
      ),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 2 },
      { ...inD, criteria: 3 },
      ...Array(8).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 2 },
        1,
        { ...inD, criteria: 0 },
        2,
        2,
      ),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
      { ...inD, criteria: 2 },
      ...Array(8).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 2 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(4).fill({ ...inD, criteria: 2 }),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
      { ...inD, criteria: 2 },
    ],
  },
  { // Catchy Tune 2
    name: "Catchy Tune 2",
    image: 32,
    critname: ["Orange", "Pineapple"],
    critweight: [45, 40, 15],
    inputs: [
      ...fillPair(
        { ...inD, criteria: 0, button: 3 },
        1,
        { ...inD, criteria: 0, button: 1 },
        1,
        3,
      ),
      ...fillPair(
        { ...inD, criteria: 1, button: 3 },
        1,
        { ...inD, criteria: 1, button: 1 },
        1,
        2,
      ),
      { ...inD, criteria: 0, button: 3 },
      { ...inD, criteria: 0, button: 1 },
      { ...inD, criteria: 1, button: 3 },
      { ...inD, criteria: 1, button: 1 },
      ...fillPair(
        { ...inD, criteria: 0, button: 3 },
        1,
        { ...inD, criteria: 0, button: 1 },
        1,
        3,
      ),
      { ...inD, criteria: 0, button: 1 },
      { ...inD, criteria: 0, button: 3 },
      ...fillPair(
        { ...inD, criteria: 0, button: 3 },
        1,
        { ...inD, criteria: 0, button: 1 },
        1,
        3,
      ),
      { ...inD, criteria: 0, button: 3 },
      { ...inD, criteria: 1, button: 1 },
      { ...inD, criteria: 0, button: 1 },
      { ...inD, criteria: 0, button: 3 },
      { ...inD, criteria: 0, button: 1 },
      { ...inD, criteria: 1, button: 3 },
      { ...inD, criteria: 0, button: 3 },
      { ...inD, criteria: 0, button: 1 },
      { ...inD, criteria: 2, button: 3 },
      { ...inD, criteria: 2, button: 1 },
      ...fillPair(
        { ...inD, criteria: 0, button: 3 },
        1,
        { ...inD, criteria: 0, button: 1 },
        1,
        2,
      ),
      { ...inD, criteria: 1, button: 3 },
      { ...inD, criteria: 1, button: 1 },
      { ...inD, criteria: 0, button: 3 },
      { ...inD, criteria: 0, button: 1 },
      { ...inD, criteria: 0, button: 3 },
      ...fillPair(
        { ...inD, criteria: 1, button: 3 },
        1,
        { ...inD, criteria: 1, button: 1 },
        1,
        2,
      ),
      { ...inD, criteria: 0, button: 3 },
      { ...inD, criteria: 0, button: 1 },
      { ...inD, criteria: 1, button: 3 },
      { ...inD, criteria: 1, button: 1 },
    ],
  },
  { // Honeybee Remix
    name: "Honeybee Remix",
    image: 33,
    critname: ["Main", "Keep"],
    critweight: [46, 44, 10],
    inputs: [
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 0, button: 3 },
      { ...inD, criteria: 0 },
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
      { ...inD, criteria: 0, button: 3 },
      { ...inD, criteria: 0 },
      ...Array(6).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0, button: 3 },
      { ...inD, criteria: 0 },
      { ...inD, criteria: 0, button: 3 },
      { ...inD, criteria: 0 },
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
      { ...inD, criteria: 0, button: 3 },
      { ...inD, criteria: 0 },
      { ...inD, criteria: 0, button: 3 },
      ...Array(2).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 2 },
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(3).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0, button: 3 },
      { ...inD, criteria: 0 },
      { ...inD, criteria: 0, button: 3 },
      { ...inD, criteria: 0 },
      ...Array(5).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 0, button: 3 },
      { ...inD, criteria: 0 },
      ...Array(6).fill({ ...inD, criteria: 1 }),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
      ...Array(5).fill({ ...inD, criteria: 0 }),
    ],
    separators: [
      { index: 0, img: 29 },
      { index: 6, img: 32 },
      { index: 8, img: 30 },
      { index: 10, img: 32 },
      { index: 12, img: 31 },
      { index: 18, img: 32 },
      { index: 22, img: 30 },
      { index: 24, img: 32 },
      { index: 27, img: 31 },
      { index: 30, img: 30 },
      { index: 32, img: 31 },
      { index: 35, img: 30 },
      { index: 37, img: 29 },
      { index: 41, img: 31 },
      { index: 44, img: 29 },
      { index: 47, img: 31 },
      { index: 50, img: 32 },
      { index: 54, img: 29 },
      { index: 59, img: 32 },
      { index: 61, img: 31 },
      { index: 67, img: 30 },
      { index: 69, img: 29 },
    ],
  },
  { // Rhythm Tweezers 2
    name: "Rhythm Tweezers 2",
    image: 34,
    critname: ["Short Hair", "Long Hair"],
    critweight: [66, 20, 14],
    inputs: [
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...Array(3).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...Array(9).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...Array(7).fill({ ...inD, criteria: 2 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...Array(44).fill({ ...inD, criteria: 0 }),
    ],
    separators: [
      { index: 4 },
      { index: 9 },
      { index: 15 },
      { index: 21 },
      { index: 29 },
      { index: 36 },
      { index: 40 },
      { index: 47 },
      { index: 51 },
      { index: 61 },
      { index: 72 },
      { index: 82 },
    ],
  },
  { // Glee Club 2
    name: "Glee Club 2",
    image: 35,
    critname: ["Open", "Close", "Yell"],
    critweight: [23, 32, 35, 10],
    inputs: [
      ...fillPair(
        { ...inD, criteria: 0, button: 5 },
        1,
        { ...inD, criteria: 1, button: 4 },
        1,
        2,
      ),
      { ...inD, criteria: 2, button: 5 },
      { ...inD, criteria: 1, button: 4 },
      ...fillPair(
        { ...inD, criteria: 0, button: 5 },
        1,
        { ...inD, criteria: 1, button: 4 },
        1,
        3,
      ),
      { ...inD, criteria: 2, button: 5 },
      { ...inD, criteria: 1, button: 4 },
      { ...inD, criteria: 3, button: 5 },
      { ...inD, criteria: 3, button: 4, multi: 0 },
      { ...inD, criteria: 3, button: 5 },
      { ...inD, criteria: 3, button: 4 },
      ...fillPair(
        { ...inD, criteria: 0, button: 5 },
        1,
        { ...inD, criteria: 1, button: 4 },
        1,
        2,
      ),
      { ...inD, criteria: 2, button: 5 },
      { ...inD, criteria: 1, button: 4 },
      ...fillPair(
        { ...inD, criteria: 0, button: 5 },
        1,
        { ...inD, criteria: 1, button: 4 },
        1,
        3,
      ),
    ],
  },
  { // Figure Fighter 2
    name: "Figure Fighter 2",
    image: 36,
    critname: ["Single Punch", "Triple Punch", "Double Punch"],
    critweight: [30, 30, 30, 10],
    inputs: [
      ...Array(6).fill({ ...inD, criteria: 2 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(6).fill({ ...inD, criteria: 2 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        6,
        { ...inD, criteria: 1 },
        3,
        4,
      ),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(6).fill({ ...inD, criteria: 2 }),
      ...Array(3).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 2 },
        2,
        { ...inD, criteria: 0 },
        2,
        2,
      ),
      { ...inD, criteria: 0 },
      ...Array(2).fill({ ...inD, criteria: 2 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 3 }),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
    ],
  },
  { // Fruit Basket 2
    name: "Fruit Basket 2",
    image: 37,
    critname: ["Apple", "Lemon", "Melon"],
    critweight: [46, 28, 10, 16],
    inputs: [
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        4,
        { ...inD, criteria: 0, multi: 2 },
        1,
        2,
      ),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 0, multi: 2 },
      { ...inD, criteria: 1 },
      ...Array(4).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 0, multi: 2 },
      { ...inD, criteria: 3 },
      ...Array(5).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 0, extracrit: 1 },
      { ...inD, criteria: 0 },
      { ...inD, criteria: 0, extracrit: 1 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2 },
      { ...inD, criteria: 1, multi: 2 },
    ],
    separators: [
      { index: 22 },
    ],
  },
  { // Machine Remix
    name: "Machine Remix",
    image: 38,
    critname: ["Main", "Repeat"],
    critweight: [44, 46, 10],
    inputs: [
      ...Array(12).fill({ ...inD, criteria: 0 }),
      ...Array(11).fill({ ...inD, criteria: 1 }),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 0, multi: 2 },
      ...Array(13).fill({ ...inD, criteria: 1 }),
      ...Array(9).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 0, button: 4 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 2 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(3).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      { ...inD, criteria: 1 },
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      { ...inD, criteria: 0, button: 4 },
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(3).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      { ...inD, criteria: 1 },
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      { ...inD, criteria: 0, button: 4 },
      ...Array(5).fill({ ...inD, criteria: 1 }),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      { ...inD, criteria: 1 },
      ...Array(14).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 0, multi: 2 },
      { ...inD, criteria: 0 },
    ],
    separators: [
      { index: 0, img: 36 },
      { index: 4, img: 37 },
      { index: 6, img: 36 },
      { index: 10, img: 37 },
      { index: 12, img: 34 },
      { index: 23, img: 37 },
      { index: 28, img: 34 },
      { index: 41, img: 36 },
      { index: 48, img: 37 },
      { index: 49, img: 37 },
      { index: 50, img: 35 },
      { index: 51, img: 36 },
      { index: 56, img: 34 },
      { index: 62, img: 37 },
      { index: 65, img: 34 },
      { index: 72, img: 35 },
      { index: 73, img: 34 },
      { index: 80, img: 37 },
      { index: 83, img: 34 },
      { index: 91, img: 35 },
      { index: 92, img: 34 },
      { index: 100, img: 36 },
      { index: 106, img: 37 },
      { index: 109, img: 36 },
      { index: 114, img: 37 },
    ],
  },
  { // The Clappy Trio 2
    name: "The Clappy Trio 2",
    image: 39,
    critname: ["Main", "Fast"],
    critweight: [50, 36, 14],
    inputs: [
      ...Array(3).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
      ...Array(7).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2 },
      ...fillPair(
        { ...inD, criteria: 0 },
        2,
        { ...inD, criteria: 1 },
        1,
        2,
      ),
      ...Array(3).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
    ],
  },
  { // Shoot-'em-up 2
    name: "Shoot-'em-up 2",
    image: 40,
    critname: ["Main", "Fast"],
    critweight: [50, 40, 10],
    inputs: [
      ...Array(35).fill({ ...inD, criteria: 0 }),
      ...Array(8).fill({ ...inD, criteria: 1 }),
      ...Array(23).fill({ ...inD, criteria: 0 }),
      ...Array(4).fill({ ...inD, criteria: 2 }),
      ...Array(31).fill({ ...inD, criteria: 1 }),
      ...Array(23).fill({ ...inD, criteria: 0 }),
    ],
    separators: [
      { index: 4 },
      { index: 8 },
      { index: 12 },
      { index: 14 },
      { index: 18 },
      { index: 22 },
      { index: 26 },
      { index: 30 },
      { index: 35 },
      { index: 43 },
      { index: 48 },
      { index: 54 },
      { index: 58 },
      { index: 62 },
      { index: 66 },
      { index: 70 },
      { index: 78 },
      { index: 86 },
      { index: 94 },
      { index: 101 },
      { index: 105 },
      { index: 110 },
      { index: 115 },
      { index: 121 },
    ],
  },
  { // Micro-Row 2
    name: "Micro-Row 2",
    image: 41,
    critname: ["Single March", "Triple March"],
    critweight: [40, 46, 14],
    inputs: [
      ...fillPair(
        { ...inD, criteria: 0 },
        14,
        { ...inD, criteria: 1 },
        3,
        2,
      ),
      ...fillPair(
        { ...inD, criteria: 0 },
        6,
        { ...inD, criteria: 1 },
        3,
        3,
      ),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 2 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        2,
        { ...inD, criteria: 1 },
        3,
        2,
      ),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...fillPair(
        { ...inD, criteria: 1 },
        3,
        { ...inD, criteria: 0 },
        2,
        3,
      ),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(6).fill({ ...inD, criteria: 1 }),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        4,
        { ...inD, criteria: 1 },
        6,
        2,
      ),
    ],
  },
  { // Second Contact
    name: "Second Contact",
    image: 42,
    critname: ["Main", "Pause", "Fast"],
    critweight: [40, 10, 40, 10],
    inputs: [
      ...combo(Array.from({ length: 5 }, () => ({ ...inD, criteria: 0 }))),
      ...combo(Array.from({ length: 4 }, () => ({ ...inD, criteria: 0 }))),
      ...combo(Array.from({ length: 5 }, () => ({ ...inD, criteria: 0 }))),
      { ...inD, criteria: 1 },
      ...combo(Array.from({ length: 5 }, () => ({ ...inD, criteria: 0 }))),
      ...combo(Array.from({ length: 4 }, () => ({ ...inD, criteria: 0 }))),
      ...combo(Array.from({ length: 5 }, () => ({ ...inD, criteria: 0 }))),
      { ...inD, criteria: 3 },
      ...combo(Array.from({ length: 4 }, () => ({ ...inD, criteria: 0 }))),
      ...combo(Array.from({ length: 4 }, () => ({ ...inD, criteria: 0 }))),
      ...combo(Array.from({ length: 4 }, () => ({ ...inD, criteria: 0 }))),
      ...combo(Array.from({ length: 7 }, () => ({ ...inD, criteria: 2 }))),
      ...combo(Array.from({ length: 4 }, () => ({ ...inD, criteria: 0 }))),
      ...combo(Array.from({ length: 2 }, () => ({ ...inD, criteria: 0 }))),
      ...combo(Array.from({ length: 2 }, () => ({ ...inD, criteria: 0 }))),
      ...combo(Array.from({ length: 4 }, () => ({ ...inD, criteria: 0 }))),
      ...combo(Array.from({ length: 6 }, () => ({ ...inD, criteria: 2 }))),
      ...combo(Array.from({ length: 5 }, () => ({ ...inD, criteria: 2 }))),
      ...combo(Array.from({ length: 2 }, () => ({ ...inD, criteria: 0 }))),
      ...combo(Array.from({ length: 5 }, () => ({ ...inD, criteria: 2 }))),
      ...combo(Array.from({ length: 6 }, () => ({ ...inD, criteria: 0 }))),
      { ...inD, criteria: 1 },
    ],
    separators: [
      { index: 5 },
      { index: 9 },
      { index: 14 },
      { index: 15 },
      { index: 20 },
      { index: 24 },
      { index: 29 },
      { index: 30 },
      { index: 34 },
      { index: 38 },
      { index: 42 },
      { index: 49 },
      { index: 53 },
      { index: 55 },
      { index: 57 },
      { index: 61 },
      { index: 67 },
      { index: 72 },
      { index: 74 },
      { index: 79 },
      { index: 85 },
    ],
  },
  { // Citrus Remix
    name: "Citrus Remix",
    image: 43,
    critname: ["Main", "Keep", "Repeat"],
    critweight: [25, 25, 40, 10],
    inputs: [
      ...Array(4).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0 },
      ...fillPair(
        { ...inD, criteria: 1 },
        5,
        { ...inD, criteria: 0 },
        2,
        2,
      ),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      ...Array(3).fill({ ...inD, criteria: 3 }),
      ...combo(Array.from({ length: 4 }, () => ({ ...inD, criteria: 2 }))),
      ...Array(6).fill({ ...inD, criteria: 1 }),
      ...combo(Array.from({ length: 5 }, () => ({ ...inD, criteria: 2 }))),
      ...Array(6).fill({ ...inD, criteria: 1 }),
      ...fillPair(
        { ...inD, criteria: 2 },
        4,
        { ...inD, criteria: 0 },
        2,
        2,
      ),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      { ...inD, criteria: 0 },
      ...Array(6).fill({ ...inD, criteria: 1 }),
      ...combo(Array.from({ length: 3 }, () => ({ ...inD, criteria: 2 }))),
    ],
    separators: [
      { index: 0, img: 41 },
      { index: 4, img: 39 },
      { index: 5, img: 41 },
      { index: 10, img: 39 },
      { index: 12, img: 41 },
      { index: 17, img: 39 },
      { index: 19, img: 40 },
      { index: 24, img: 42 },
      { index: 28, img: 41 },
      { index: 34, img: 42 },
      { index: 39, img: 41 },
      { index: 45, img: 40 },
      { index: 49, img: 39 },
      { index: 51, img: 40 },
      { index: 55, img: 39 },
      { index: 57, img: 40 },
      { index: 59, img: 39 },
      { index: 60, img: 41 },
      { index: 66, img: 42 },
    ],
  },
  { // Rat Race
    name: "Rat Race",
    image: 44,
    critname: ["Halt", "Dash"],
    critweight: [38, 52, 10],
    inputs: [
      ...fillPair(
        { ...inD, criteria: 0, button: 4 },
        1,
        { ...inD, criteria: 1, button: 5 },
        1,
        6,
      ),
      { ...inD, criteria: 2, button: 4 },
      { ...inD, criteria: 1, button: 5 },
      ...fillPair(
        { ...inD, criteria: 0, button: 4 },
        1,
        { ...inD, criteria: 1, button: 5 },
        1,
        3,
      ),
    ],
  },
  { // Fan Club
    name: "Fan Club",
    image: 45,
    critname: ["Claps", "I Suppose!"],
    critweight: [40, 42, 18],
    inputs: [
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 1, button: 4 },
      { ...inD, criteria: 1, button: 5 },
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      { ...inD, criteria: 2, button: 4 },
      { ...inD, criteria: 2, button: 5 },
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 1, button: 4 },
      { ...inD, criteria: 1, button: 5 },
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 1, button: 4 },
      { ...inD, criteria: 1, button: 5 },
      ...Array(4).fill({ ...inD, criteria: 0 }),
    ],
  },
  { // Working Dough
    name: "Working Dough",
    image: 46,
    critname: ["Small Ball", "Big Ball"],
    critweight: [52, 40, 8],
    inputs: [
      ...Array(24).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 2 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        6,
        { ...inD, criteria: 1, button: 2 },
        2,
        2,
      ),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        2,
        { ...inD, criteria: 1, button: 2 },
        1,
        2,
      ),
      ...fillPair(
        { ...inD, criteria: 1, button: 2 },
        1,
        { ...inD, criteria: 0 },
        7,
        2,
      ),
      ...Array(12).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1, button: 2 }),
      ...Array(18).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        1,
        { ...inD, criteria: 1, button: 2 },
        1,
        2,
      ),
      ...Array(3).fill({ ...inD, criteria: 0 }),
      ...Array(4).fill({ ...inD, criteria: 1, button: 2 }),
      { ...inD, criteria: 2 },
      ...Array(9).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 2 },
    ],
    separators: [
      { index: 3 },
      { index: 9 },
      { index: 13 },
      { index: 17 },
      { index: 20 },
      { index: 25 },
      { index: 29 },
      { index: 35 },
      { index: 38 },
      { index: 43 },
      { index: 47 },
      { index: 51 },
      { index: 53 },
      { index: 55 },
      { index: 58 },
      { index: 63 },
      { index: 74 },
      { index: 82 },
      { index: 90 },
      { index: 102 },
      { index: 104 },
      { index: 106 },
      { index: 110 },
      { index: 113 },
      { index: 114 },
      { index: 117 },
      { index: 120 },
    ],
  },
  { // Animal Acrobat
    name: "Animal Acrobat",
    image: 47,
    critname: ["Main", "Giraffe Jump", "Giraffe Catch"],
    critweight: [34, 25, 28, 13],
    inputs: [
      ...Array(2).fill(
        combo([
          { ...inD, criteria: 0, button: 4, square: true },
          { ...inD, criteria: 0, button: 5, square: true },
        ]),
      ).flat(),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 2, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 2, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 2, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 2, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
      ...Array(3).fill(
        combo([
          { ...inD, criteria: 0, button: 4, square: true },
          { ...inD, criteria: 0, button: 5, square: true },
        ]),
      ).flat(),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 3, button: 4 },
        { ...inD, criteria: 3, button: 5 },
      ]),
      ...combo([
        { ...inD, criteria: 2, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 2, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
    ],
  },
  { // Donut Remix
    name: "Donut Remix",
    image: 48,
    critname: ["Main", "Repeat"],
    critweight: [70, 20, 10],
    inputs: [
      ...Array(2).fill(
        combo([
          { ...inD, criteria: 0, button: 4, square: true },
          { ...inD, criteria: 0, button: 5, square: true },
        ]),
      ).flat(),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 0, button: 4 },
      { ...inD, criteria: 0, button: 5 },
      ...Array(6).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0, button: 4 },
      { ...inD, criteria: 0, button: 5 },
      ...Array(4).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 1, button: 2 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 0, button: 4 },
      { ...inD, criteria: 0, button: 5 },
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 1, button: 2 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 0, button: 4 },
      { ...inD, criteria: 0, button: 5 },
      { ...inD, criteria: 0, button: 4 },
      { ...inD, criteria: 2, button: 5 },
      ...Array(3).fill(
        combo([
          { ...inD, criteria: 0, button: 4, square: true },
          { ...inD, criteria: 0, button: 5, square: true },
        ]),
      ).flat(),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 1, button: 2 }),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 0, button: 4 },
      { ...inD, criteria: 0, button: 5 },
      ...Array(3).fill(
        combo([
          { ...inD, criteria: 0, button: 4, square: true },
          { ...inD, criteria: 0, button: 5, square: true },
        ]),
      ).flat(),
    ],
    separators: [
      { index: 0, img: 47 },
      { index: 4, img: 45 },
      { index: 12, img: 46 },
      { index: 18, img: 44 },
      { index: 20, img: 46 },
      { index: 25, img: 45 },
      { index: 29, img: 46 },
      { index: 34, img: 45 },
      { index: 38, img: 44 },
      { index: 40, img: 47 },
      { index: 46, img: 46 },
      { index: 50, img: 45 },
      { index: 54, img: 44 },
      { index: 56, img: 47 },
    ],
  },
  { // Sneaky Spirits 2
    name: "Sneaky Spirits 2",
    image: 49,
    critname: ["Main", "Quiet", "Slow"],
    critweight: [32, 24, 24, 20],
    inputs: [
      ...Array(4).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
      { ...inD, criteria: 2 },
      { ...inD, criteria: 0 },
      { ...inD, criteria: 1 },
      ...Array(2).fill({ ...inD, criteria: 2 }),
      { ...inD, criteria: 3 },
      { ...inD, criteria: 0 },
    ],
  },
  { // Rhythm Rally 2
    name: "Rhythm Rally 2",
    image: 50,
    critname: ["Normal Swing", "Fast Swing", "Long Swing"],
    critweight: [40, 32, 20, 8],
    inputs: [
      { ...inD, criteria: 2 },
      ...fillPair(
        { ...inD, criteria: 0 },
        3,
        { ...inD, criteria: 1 },
        1,
        2,
      ),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        3,
        { ...inD, criteria: 1 },
        1,
        2,
      ),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        3,
        { ...inD, criteria: 1 },
        1,
        2,
      ),
      { ...inD, criteria: 0 },
      ...Array(3).fill({ ...inD, criteria: 2 }),
      { ...inD, criteria: 3 },
      ...fillPair(
        { ...inD, criteria: 0 },
        3,
        { ...inD, criteria: 1 },
        1,
        2,
      ),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2 },
    ],
  },
  { // Flipper-Flop 2
    name: "Flipper-Flop 2",
    image: 51,
    critname: ["Flip", "Triple Flip", "Flipper-Roll"],
    critweight: [30, 30, 30, 10],
    inputs: [
      ...Array(10).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(3).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2, button: 2 },
      ...Array(10).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 2, button: 2 }),
      ...Array(10).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0 },
      ...Array(3).fill({ ...inD, criteria: 2, button: 2 }),
      ...Array(10).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(4).fill({ ...inD, criteria: 2, button: 2 }),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(5).fill({ ...inD, criteria: 2, button: 2 }),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(6).fill({ ...inD, criteria: 2, button: 2 }),
      ...Array(8).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(7).fill({ ...inD, criteria: 2, button: 2 }),
      ...Array(7).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(8).fill({ ...inD, criteria: 2, button: 2 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 3 }),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0 },
      { ...inD, criteria: 2, button: 2 },
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 2, button: 2 }),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(9).fill({ ...inD, criteria: 2, button: 2 }),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0 },
      { ...inD, criteria: 2, button: 2 },
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 2, button: 2 }),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(10).fill({ ...inD, criteria: 2, button: 2 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        2,
        { ...inD, criteria: 1 },
        3,
        3,
      ),
      ...Array(3).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2 },
    ],
  },
  { // LumBEARjack 2
    name: "LumBEARjack 2",
    image: 52,
    critname: ["Log", "Huge Log", "Not a Log", "Fridge"],
    critweight: [30, 30, 10, 16, 14],
    inputs: [
      ...Array(3).fill({ ...inD, criteria: 0 }),
      ...combo(Array.from({ length: 2 }, () => (
        { ...inD, criteria: 0, square: true }
      ))),
      { ...inD, criteria: 0 },
      ...combo(Array.from({ length: 2 }, () => (
        { ...inD, criteria: 0, square: true }
      ))),
      { ...inD, criteria: 0 },
      ...combo(Array.from({ length: 4 }, () => (
        { ...inD, criteria: 1, square: true }
      ))),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...combo(Array.from({ length: 2 }, () => (
        { ...inD, criteria: 0, square: true }
      ))),
      { ...inD, criteria: 2 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(5).fill(
        combo([
          { ...inD, criteria: 0, square: true },
          { ...inD, criteria: 0, square: true },
        ]),
      ).flat(),
      ...combo(Array.from({ length: 4 }, () => (
        { ...inD, criteria: 1, square: true }
      ))),
      ...combo(Array.from({ length: 2 }, () => (
        { ...inD, criteria: 0, square: true }
      ))),
      { ...inD, criteria: 0 },
      ...Array(4).fill(
        combo([
          { ...inD, criteria: 0, square: true },
          { ...inD, criteria: 0, square: true },
        ]),
      ).flat(),
      { ...inD, criteria: 0 },
      ...combo(Array.from({ length: 4 }, () => (
        { ...inD, criteria: 1, square: true }
      ))),
      ...combo(Array.from({ length: 2 }, () => (
        { ...inD, criteria: 0, square: true }
      ))),
      ...Array(3).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill(
        combo([
          { ...inD, criteria: 0, square: true },
          { ...inD, criteria: 0, square: true },
        ]),
      ).flat(),
      { ...inD, criteria: 0 },
      ...combo(Array.from({ length: 4 }, () => (
        { ...inD, criteria: 4, square: true }
      ))),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...combo(Array.from({ length: 2 }, () => (
        { ...inD, criteria: 0, square: true }
      ))),
      { ...inD, criteria: 2 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(4).fill(
        combo([
          { ...inD, criteria: 0, square: true },
          { ...inD, criteria: 0, square: true },
        ]),
      ).flat(),
      { ...inD, criteria: 0 },
      ...combo(Array.from({ length: 4 }, () => (
        { ...inD, criteria: 1, square: true }
      ))),
      ...combo(Array.from({ length: 4 }, () => (
        { ...inD, criteria: 3, square: true }
      ))),
    ],
    separators: [
      { index: 34 },
    ],
  },
  { // Barbershop Remix
    name: "Barbershop Remix",
    image: 53,
    critname: ["Main", "Keep", "Aim"],
    critweight: [25, 40, 25, 10],
    inputs: [
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...combo(Array.from({ length: 2 }, () => (
        { ...inD, criteria: 0, square: true }
      ))),
      { ...inD, criteria: 0 },
      { ...inD, criteria: 2 },
      ...Array(2).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 2 },
      ...Array(16).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 1, button: 2 }),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...combo(Array.from({ length: 4 }, () => (
        { ...inD, criteria: 0, square: true }
      ))),
      { ...inD, criteria: 1 },
      { ...inD, criteria: 3 },
      ...Array(2).fill({ ...inD, criteria: 2 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...combo(Array.from({ length: 2 }, () => (
        { ...inD, criteria: 0, square: true }
      ))),
      ...combo(Array.from({ length: 2 }, () => (
        { ...inD, criteria: 0, square: true }
      ))),
      ...Array(13).fill({ ...inD, criteria: 1 }),
      ...Array(4).fill({ ...inD, criteria: 1, button: 2 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...combo(Array.from({ length: 2 }, () => (
        { ...inD, criteria: 0, square: true }
      ))),
      { ...inD, criteria: 0 },
      ...combo(Array.from({ length: 4 }, () => (
        { ...inD, criteria: 0, square: true }
      ))),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
    ],
    separators: [
      { index: 0, img: 50 },
      { index: 3, img: 52 },
      { index: 8, img: 49 },
      { index: 9, img: 50 },
      { index: 11, img: 49 },
      { index: 12, img: 50 },
      { index: 13, img: 51 },
      { index: 30, img: 52 },
      { index: 38, img: 50 },
      { index: 40, img: 49 },
      { index: 42, img: 52 },
      { index: 48, img: 51 },
      { index: 65, img: 52 },
      { index: 74, img: 50 },
      { index: 76, img: 49 },
    ],
  },
  { // Tap Trial
    name: "Tap Trial",
    image: 54,
    critname: ["Single Tap", "Double Tap", "Triple Tap", "Jump Tap"],
    critweight: [25, 25, 25, 17, 8],
    inputs: [
      { ...inD, criteria: 3 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 2 }),
      ...Array(3).fill({ ...inD, criteria: 3 }),
      ...fillPair(
        { ...inD, criteria: 1 },
        2,
        { ...inD, criteria: 0 },
        2,
        4,
      ),
      { ...inD, criteria: 0 },
      ...Array(3).fill({ ...inD, criteria: 2 }),
      { ...inD, criteria: 0 },
      ...fillPair(
        { ...inD, criteria: 1 },
        2,
        { ...inD, criteria: 0 },
        3,
        2,
      ),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(4).fill({ ...inD, criteria: 1 }),
      ...Array(3).fill({ ...inD, criteria: 2 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 2 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        1,
        { ...inD, criteria: 3 },
        2,
        3,
      ),
      { ...inD, criteria: 0 },
      ...Array(3).fill({ ...inD, criteria: 4 }),
      ...Array(3).fill({ ...inD, criteria: 2 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0 },
      ...Array(3).fill({ ...inD, criteria: 2 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0 },
      ...Array(3).fill({ ...inD, criteria: 2 }),
      ...Array(3).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 3 },
    ],
  },
  { // Frog Hop
    name: "Frog Hop",
    image: 55,
    critname: ["Main", "Cue", "Spin"],
    critweight: [34, 30, 26, 10],
    inputs: [
      { ...inD, criteria: 0 },
      ...fillPair({ ...inD, criteria: 0 }, 6, { ...inD, criteria: 1 }, 2, 4),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(7).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2, button: 6 },
      { ...inD, criteria: 2, button: 7 },
      { ...inD, criteria: 0 },
      ...fillPair({ ...inD, criteria: 0 }, 6, { ...inD, criteria: 1 }, 2, 4),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(7).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2, button: 6 },
      { ...inD, criteria: 2, button: 7 },
      { ...inD, criteria: 0 },
      ...fillPair({ ...inD, criteria: 0 }, 10, { ...inD, criteria: 1 }, 2, 2),
      ...fillPair({ ...inD, criteria: 0 }, 2, { ...inD, criteria: 1 }, 2, 2),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 3, button: 6 },
      { ...inD, criteria: 3, button: 7 },
      ...Array(7).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(7).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2, button: 6 },
      { ...inD, criteria: 2, button: 7 },
      ...Array(7).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...fillPair({ ...inD, criteria: 0 }, 2, { ...inD, criteria: 1 }, 3, 2),
      ...Array(18).fill({ ...inD, criteria: 0 }),
      ...fillPair({ ...inD, criteria: 0 }, 2, { ...inD, criteria: 1 }, 2, 3),
      { ...inD, criteria: 0 },
      { ...inD, criteria: 2, button: 6 },
      { ...inD, criteria: 2, button: 7 },
      ...Array(7).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(7).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2, button: 6 },
      { ...inD, criteria: 2, button: 7 },
      ...Array(7).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...fillPair({ ...inD, criteria: 0 }, 2, { ...inD, criteria: 1 }, 3, 2),
      ...Array(15).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2, button: 6 },
      { ...inD, criteria: 2, button: 7 },
    ],
  },
  { // Ringside
    name: "Ringside",
    image: 56,
    critname: ["Speak", "Flex", "Pose"],
    critweight: [23, 29, 40, 8],
    inputs: [
      { ...inD, criteria: 0 },
      ...fillPair(
        { ...inD, criteria: 0 },
        1,
        { ...inD, criteria: 2, button: 2 },
        1,
        2,
      ),
      ...fillPair(
        { ...inD, criteria: 0 },
        1,
        { ...inD, criteria: 1 },
        2,
        2,
      ),
      ...fillPair(
        { ...inD, criteria: 0 },
        1,
        { ...inD, criteria: 2, button: 2 },
        1,
        2,
      ),
      { ...inD, criteria: 0 },
      ...Array(2).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0 },
      { ...inD, criteria: 2, button: 2 },
      { ...inD, criteria: 0 },
      ...fillPair(
        { ...inD, criteria: 1 },
        2,
        { ...inD, criteria: 2, button: 2 },
        1,
        2,
      ),
      { ...inD, criteria: 2, button: 2 },
      ...Array(2).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 2, button: 2 },
      { ...inD, criteria: 3, button: 2 },
      { ...inD, criteria: 0 },
      ...fillPair(
        { ...inD, criteria: 0 },
        2,
        { ...inD, criteria: 1 },
        2,
        2,
      ),
      ...Array(4).fill({ ...inD, criteria: 2, button: 2 }),
    ],
  },
  { // Tangotronic 3000
    name: "Tangotronic 3000",
    image: 57,
    critname: ["Double Pose", "Triple Pose", "Spin"],
    critweight: [30, 24, 30, 16],
    inputs: [
      ...Array(5).fill(
        combo([
          { ...inD, criteria: 0, square: true },
          { ...inD, criteria: 0, square: true },
        ]),
      ).flat(),
      ...combo([
        { ...inD, criteria: 2, button: 6 },
        { ...inD, criteria: 2, button: 7 },
      ]),
      ...combo(Array.from({ length: 3 }, () => (
        { ...inD, criteria: 1, square: true }
      ))),
      ...combo(Array.from({ length: 3 }, () => (
        { ...inD, criteria: 1, square: true }
      ))),
      ...Array(2).fill(
        combo([
          { ...inD, criteria: 0, square: true },
          { ...inD, criteria: 0, square: true },
        ]),
      ).flat(),
      ...combo([
        { ...inD, criteria: 3, button: 6 },
        { ...inD, criteria: 3, button: 7 },
      ]),
      ...combo(Array.from({ length: 2 }, () => (
        { ...inD, criteria: 0, square: true }
      ))),
      ...combo(Array.from({ length: 3 }, () => (
        { ...inD, criteria: 1, square: true }
      ))),
      ...combo(Array.from({ length: 2 }, () => (
        { ...inD, criteria: 0, square: true }
      ))),
      ...combo(Array.from({ length: 3 }, () => (
        { ...inD, criteria: 1, square: true }
      ))),
      ...Array(3).fill(
        combo([
          { ...inD, criteria: 0, square: true },
          { ...inD, criteria: 0, square: true },
        ]),
      ).flat(),
      ...combo([
        { ...inD, criteria: 2, button: 6 },
        { ...inD, criteria: 2, button: 7 },
      ]),
      ...Array(2).fill(
        combo([
          { ...inD, criteria: 0, square: true },
          { ...inD, criteria: 0, square: true },
        ]),
      ).flat(),
      ...combo([
        { ...inD, criteria: 2, button: 6 },
        { ...inD, criteria: 2, button: 7 },
      ]),
    ],
  },
  { // Songbird Remix
    name: "Songbird Remix",
    image: 58,
    critname: ["Main", "Keep"],
    critweight: [65, 25, 10],
    inputs: [
      ...Array(13).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0, button: 2 },
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(6).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(5).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0, button: 2 },
      ...Array(5).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      ...combo(Array.from({ length: 2 }, () => (
        { ...inD, criteria: 0, square: true }
      ))),
      ...combo(Array.from({ length: 2 }, () => (
        { ...inD, criteria: 0, square: true }
      ))),
      ...combo(Array.from({ length: 3 }, () => (
        { ...inD, criteria: 0, square: true }
      ))),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 0, button: 6 },
        { ...inD, criteria: 0, button: 7 },
      ]),
      ...Array(14).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0, button: 2 },
      ...Array(14).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 0, button: 6 },
        { ...inD, criteria: 0, button: 7 },
      ]),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 0, button: 6 },
        { ...inD, criteria: 0, button: 7 },
      ]),
    ],
    separators: [
      { index: 0, img: 55 },
      { index: 13, img: 56 },
      { index: 14, img: 54 },
      { index: 18, img: 55 },
      { index: 31, img: 56 },
      { index: 32, img: 54 },
      { index: 37, img: 56 },
      { index: 39, img: 57 },
      { index: 46, img: 54 },
      { index: 52, img: 57 },
      { index: 54, img: 55 },
      { index: 68, img: 56 },
      { index: 69, img: 54 },
      { index: 77, img: 56 },
      { index: 78, img: 54 },
      { index: 81, img: 56 },
      { index: 83, img: 57 },
      { index: 85, img: 56 },
      { index: 86, img: 54 },
      { index: 89, img: 56 },
      { index: 91, img: 57 },
    ],
  },
  { // Ninja Bodyguard
    name: "Ninja Bodyguard",
    image: 59,
    critname: ["Main"],
    critweight: [70, 30],
    inputs: [
      ...fillPair(
        { ...inD, criteria: 0 },
        2,
        { ...inD, criteria: 0, button: 3 },
        1,
        2,
      ),
      ...Array(3).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 0, button: 3 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 1 },
        1,
        { ...inD, criteria: 1, button: 3 },
        1,
        2,
      ),
      { ...inD, criteria: 0 },
    ],
    separators: [
      { index: 1 },
      { index: 3 },
      { index: 4 },
      { index: 7 },
      { index: 8 },
      { index: 11 },
      { index: 12 },
      { index: 16 },
    ],
  },
  { // Freeze Frame
    name: "Freeze Frame",
    image: 60,
    critname: ["Triple Car", "Double Car", "Fast Car"],
    critweight: [30, 20, 40, 10],
    inputs: [
      ...fillPair(
        { ...inD, criteria: 0 },
        6,
        { ...inD, criteria: 2 },
        2,
        2,
      ),
      ...Array(4).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 2 },
      ...Array(4).fill({ ...inD, criteria: 1 }),
      ...Array(3).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 3 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      ...Array(9).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2 },
    ],
  },
  { // Launch Party
    name: "Launch Party",
    image: 61,
    critname: ["Act 1", "Act 2"],
    critweight: [40, 52, 8],
    inputs: [
      ...Array(20).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2 },
      ...Array(20).fill({ ...inD, criteria: 1 }),
    ],
  },
  { // Pajama Party
    name: "Pajama Party",
    image: 62,
    critname: ["Jump", "Throw", "Sleep"],
    critweight: [40, 20, 15, 25],
    inputs: [
      ...Array(18).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2 },
      ...Array(3).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 3, button: 6 },
      { ...inD, criteria: 3, button: 7 },
      { ...inD, criteria: 2 },
    ],
  },
  { // Marching Orders
    name: "Marching Orders",
    image: 63,
    critname: ["March", "Halt", "Turn"],
    critweight: [40, 25, 25, 10],
    inputs: [
      ...fillPair(
        { ...inD, criteria: 0 },
        11,
        { ...inD, criteria: 1, button: 2 },
        1,
        2,
      ),
      { ...inD, criteria: 2, button: 3 },
      ...Array(3).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 2 },
      { ...inD, criteria: 2, button: 3 },
      ...Array(15).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 3, button: 2 },
      ...Array(2).fill({ ...inD, criteria: 2, button: 3 }),
      ...Array(18).fill({ ...inD, criteria: 0 }),
    ],
  },
  { // Munchy Monk
    name: "Munchy Monk",
    image: 64,
    critname: ["Eat One", "Eat Two", "Eat Three"],
    critweight: [30, 30, 30, 10],
    inputs: [
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 2 }),
      ...fillPair(
        { ...inD, criteria: 1 },
        2,
        { ...inD, criteria: 0 },
        7,
        3,
      ),
      ...fillPair(
        { ...inD, criteria: 1 },
        2,
        { ...inD, criteria: 0 },
        1,
        4,
      ),
      ...Array(3).fill({ ...inD, criteria: 3 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        2,
        { ...inD, criteria: 2 },
        3,
        3,
      ),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0 },
      ...Array(2).fill({ ...inD, criteria: 1 }),
    ],
  },
  { // See-Saw
    name: "See-Saw",
    image: 65,
    critname: ["Main", "High Jump"],
    critweight: [40, 50, 10],
    inputs: [
      ...Array(10).fill({ ...inD, criteria: 0 }),
      ...Array(8).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 2 },
      { ...inD, criteria: 1 },
      ...Array(20).fill({ ...inD, criteria: 0 }),
      ...Array(15).fill({ ...inD, criteria: 1 }),
      ...Array(5).fill({ ...inD, criteria: 0 }),
    ],
  },
  { // Blue Bear
    name: "Blue Bear",
    image: 66,
    critname: ["Donut", "Cake"],
    critweight: [35, 40, 25],
    inputs: [
      ...Array(3).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 1, button: 3 },
        1,
        { ...inD, criteria: 0 },
        2,
        2,
      ),
      ...fillPair(
        { ...inD, criteria: 0 },
        2,
        { ...inD, criteria: 1, button: 3 },
        3,
        2,
      ),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1, button: 3 }),
      ...Array(6).fill({ ...inD, criteria: 2 }),
      { ...inD, criteria: 2, button: 3 },
      ...fillPair(
        { ...inD, criteria: 0 },
        1,
        { ...inD, criteria: 1, button: 3 },
        1,
        2,
      ),
      { ...inD, criteria: 1, button: 3 },
    ],
  },
  { // Space Dance
    name: "Space Dance",
    image: 67,
    critname: ["Pose", "Squat", "Punch"],
    critweight: [40, 25, 25, 10],
    inputs: [
      { ...inD, criteria: 0, button: 3 },
      { ...inD, criteria: 2 },
      { ...inD, criteria: 0, button: 3 },
      { ...inD, criteria: 1, button: 3 },
      { ...inD, criteria: 2 },
      ...Array(3).fill({ ...inD, criteria: 0, button: 3 }),
      ...fillPair(
        { ...inD, criteria: 1, button: 3 },
        1,
        { ...inD, criteria: 0, button: 3 },
        5,
        2,
      ),
      { ...inD, criteria: 0, button: 3 },
      ...Array(4).fill({ ...inD, criteria: 1, button: 3 }),
      ...Array(6).fill({ ...inD, criteria: 0, button: 3 }),
      ...Array(2).fill({ ...inD, criteria: 1, button: 3 }),
      ...Array(3).fill({ ...inD, criteria: 0, button: 3 }),
      { ...inD, criteria: 1, button: 3 },
      { ...inD, criteria: 3 },
      ...Array(3).fill({ ...inD, criteria: 1, button: 3 }),
      { ...inD, criteria: 2 },
      ...Array(2).fill({ ...inD, criteria: 1, button: 3 }),
      ...Array(2).fill({ ...inD, criteria: 0, button: 3 }),
      { ...inD, criteria: 2 },
      { ...inD, criteria: 0, button: 3 },
      { ...inD, criteria: 1, button: 3 },
      { ...inD, criteria: 2 },
    ],
  },
  { // Lockstep
    name: "Lockstep",
    image: 68,
    critname: ["Onbeat", "Offbeat", "Switch"],
    critweight: [20, 34, 40, 6],
    inputs: [
      ...Array(15).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      ...Array(15).fill({ ...inD, criteria: 1 }),
      ...Array(3).fill({ ...inD, criteria: 2 }),
      ...Array(13).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      ...Array(15).fill({ ...inD, criteria: 1 }),
      ...Array(3).fill({ ...inD, criteria: 2 }),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      ...Array(7).fill({ ...inD, criteria: 1 }),
      ...Array(3).fill({ ...inD, criteria: 2 }),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      ...Array(4).fill({ ...inD, criteria: 1 }),
      ...fillPair(
        { ...inD, criteria: 1 },
        3,
        { ...inD, criteria: 2 },
        6,
        3,
      ),
      ...Array(7).fill({ ...inD, criteria: 1 }),
      ...Array(3).fill({ ...inD, criteria: 2 }),
      ...Array(9).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      ...Array(5).fill({ ...inD, criteria: 1 }),
      ...Array(3).fill({ ...inD, criteria: 2 }),
      ...Array(7).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      ...Array(5).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 2 },
      { ...inD, criteria: 3 },
      { ...inD, criteria: 2 },
      ...Array(15).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      ...Array(15).fill({ ...inD, criteria: 1 }),
      ...Array(3).fill({ ...inD, criteria: 2 }),
      ...Array(30).fill({ ...inD, criteria: 0 }),
    ],
  },
  { // Cheer Readers
    name: "Cheer Readers",
    image: 69,
    critname: ["Main", "OK It's On!"],
    critweight: [60, 30, 10],
    inputs: [
      ...Array(13).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(27).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      { ...inD, criteria: 0 },
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      { ...inD, criteria: 0 },
      { ...inD, criteria: 2 },
      ...Array(12).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
    ],
  },
  { // Kitties!
    name: "Kitties!",
    image: 70,
    critname: ["Clap", "Spin", "Fish"],
    critweight: [40, 36, 14, 10],
    inputs: [
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 1, button: 6 },
        { ...inD, criteria: 1, button: 7 },
      ]),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 1, button: 6 },
        { ...inD, criteria: 1, button: 7 },
      ]),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 1, button: 6 },
        { ...inD, criteria: 1, button: 7 },
      ]),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2 },
      ...Array(8).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 1, button: 6 },
        { ...inD, criteria: 1, button: 7 },
      ]),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 1, button: 6 },
        { ...inD, criteria: 1, button: 7 },
      ]),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 1, button: 6 },
        { ...inD, criteria: 1, button: 7 },
      ]),
      ...combo([
        { ...inD, criteria: 1, button: 6 },
        { ...inD, criteria: 1, button: 7 },
      ]),
      ...combo([
        { ...inD, criteria: 1, button: 6 },
        { ...inD, criteria: 1, button: 7 },
      ]),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 3 },
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 1, button: 6 },
        { ...inD, criteria: 1, button: 7 },
      ]),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
    ],
  },
  { // The Snappy Trio
    name: "The Snappy Trio",
    image: 71,
    critname: ["Main", "Offbeat"],
    critweight: [70, 10, 20],
    inputs: [
      ...Array(21).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(13).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2 },
      ...Array(3).fill({ ...inD, criteria: 0 }),
    ],
  },
  { // Fan Club 2
    name: "Fan Club 2",
    image: 72,
    critname: ["Claps", "Ooh!", "I Suppose!"],
    critweight: [28, 28, 36, 8],
    inputs: [
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      { ...inD, criteria: 2, button: 4 },
      { ...inD, criteria: 2, button: 5 },
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 3 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      { ...inD, criteria: 2, button: 4 },
      { ...inD, criteria: 2, button: 5 },
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      { ...inD, criteria: 2, button: 4 },
      { ...inD, criteria: 2, button: 5 },
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      { ...inD, criteria: 2, button: 4 },
      { ...inD, criteria: 2, button: 5 },
      ...fillPair({ ...inD, criteria: 1 }, 2, { ...inD, criteria: 0 }, 4, 2),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      { ...inD, criteria: 2, button: 4 },
      { ...inD, criteria: 2, button: 5 },
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      { ...inD, criteria: 2, button: 4 },
      { ...inD, criteria: 2, button: 5 },
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      { ...inD, criteria: 2, button: 4 },
      { ...inD, criteria: 2, button: 5 },
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      { ...inD, criteria: 2, button: 4 },
      { ...inD, criteria: 2, button: 5 },
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      { ...inD, criteria: 2, button: 4 },
      { ...inD, criteria: 2, button: 5 },
      ...Array(4).fill({ ...inD, criteria: 0 }),
    ],
    separators: [
      { index: 38 },
      { index: 62 },
    ],
  },
  { // Figure Fighter 3
    name: "Figure Fighter 3",
    image: 73,
    critname: ["Single Punch", "Triple Punch", "Double Punch"],
    critweight: [18, 35, 37, 10],
    inputs: [
      ...Array(2).fill({ ...inD, criteria: 2 }),
      ...fillPair(
        { ...inD, criteria: 2 },
        2,
        { ...inD, criteria: 1 },
        3,
        2,
      ),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...fillPair(
        { ...inD, criteria: 2 },
        2,
        { ...inD, criteria: 0 },
        4,
        2,
      ),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 3 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(4).fill({ ...inD, criteria: 2 }),
      ...fillPair(
        { ...inD, criteria: 2 },
        2,
        { ...inD, criteria: 1 },
        3,
        2,
      ),
      ...fillPair(
        { ...inD, criteria: 2 },
        10,
        { ...inD, criteria: 1 },
        3,
        2,
      ),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
    ],
  },
  { // Jungle Gymnast
    name: "Jungle Gymnast",
    image: 74,
    critname: ["Main", "Long Vine", "Short Vine"],
    critweight: [30, 30, 30, 10],
    inputs: [
      ...Array(8).fill(
        combo([
          { ...inD, criteria: 0, button: 4, square: true },
          { ...inD, criteria: 0, button: 5, square: true },
        ]),
      ).flat(),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 3, button: 4 },
        { ...inD, criteria: 3, button: 5 },
      ]),
      ...Array(2).fill(
        combo([
          { ...inD, criteria: 0, button: 4, square: true },
          { ...inD, criteria: 0, button: 5, square: true },
        ]),
      ).flat(),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 2, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 2, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
      ...Array(3).fill(
        combo([
          { ...inD, criteria: 0, button: 4, square: true },
          { ...inD, criteria: 0, button: 5, square: true },
        ]),
      ).flat(),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 2, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 2, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 2, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 2, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
      ...Array(2).fill(
        combo([
          { ...inD, criteria: 0, button: 4, square: true },
          { ...inD, criteria: 0, button: 5, square: true },
        ]),
      ).flat(),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 2, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 2, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 2, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 2, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
    ],
  },
  { // Left-Hand Remix
    name: "Left-Hand Remix",
    image: 75,
    critname: ["Main", "Aim", "Repeat"],
    critweight: [60, 6, 24, 10],
    inputs: [
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 0, button: 3 },
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill(
        combo([
          { ...inD, criteria: 0, button: 4, square: true },
          { ...inD, criteria: 0, button: 5, square: true },
        ]),
      ).flat(),
      ...Array(11).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      { ...inD, criteria: 2, button: 2 },
      ...Array(5).fill({ ...inD, criteria: 2 }),
      { ...inD, criteria: 2, button: 2 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 0, button: 3 }),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(9).fill({ ...inD, criteria: 2 }),
      ...Array(10).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 0, button: 2 },
      ...Array(12).fill({ ...inD, criteria: 2 }),
      ...combo([
        { ...inD, criteria: 2, button: 4, square: true },
        { ...inD, criteria: 2, button: 5, square: true },
      ]),
      { ...inD, criteria: 2 },
      ...combo(
        Array.from(
          { length: 4 },
          () => ({ ...inD, criteria: 2 }),
        ),
      ),
      ...combo(
        Array.from(
          { length: 3 },
          () => ({ ...inD, criteria: 2 }),
        ),
      ),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 3 }),
      ...Array(8).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 0, button: 6 },
        { ...inD, criteria: 0, button: 7 },
      ]),
      { ...inD, criteria: 1 },
      ...fillPair(
        { ...inD, criteria: 0 },
        1,
        { ...inD, criteria: 0, button: 3 },
        1,
        2,
      ),
      { ...inD, criteria: 0, button: 3 },
    ],
    separators: [
      { index: 0, img: 66 },
      { index: 7, img: 30 },
      { index: 11, img: 26 },
      { index: 15, img: 24 },
      { index: 22, img: 46 },
      { index: 31, img: 60 },
      { index: 33, img: 67 },
      { index: 36, img: 62 },
      { index: 39, img: 40 },
      { index: 48, img: 54 },
      { index: 55, img: 56 },
      { index: 59, img: 34 },
      { index: 74, img: 42 },
      { index: 81, img: 25 },
      { index: 90, img: 70 },
      { index: 98, img: 14 },
      { index: 99, img: 66 },
    ],
  },
  { // Tap Trial 2
    name: "Tap Trial 2",
    image: 76,
    critname: ["Single Tap", "Double Tap", "Triple Tap", "Jump Tap"],
    critweight: [37, 10, 28, 15, 10],
    inputs: [
      { ...inD, criteria: 0 },
      { ...inD, criteria: 3 },
      ...Array(3).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 2 }),
      ...Array(2).fill({ ...inD, criteria: 3 }),
      ...Array(3).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 2 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 3 },
      ...Array(3).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 4 }),
      ...Array(14).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 2 }),
      ...Array(2).fill({ ...inD, criteria: 3 }),
      ...Array(7).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 2 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0 },
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(3).fill({ ...inD, criteria: 2 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 3 },
    ],
  },
  { // Jumpin' Jazz
    name: "Jumpin' Jazz",
    image: 77,
    critname: ["Main", "Cue", "Spin"],
    critweight: [36, 30, 26, 8],
    inputs: [
      { ...inD, criteria: 0 },
      ...fillPair({ ...inD, criteria: 0 }, 6, { ...inD, criteria: 1 }, 2, 4),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(7).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2, button: 6 },
      { ...inD, criteria: 2, button: 7 },
      { ...inD, criteria: 0 },
      ...fillPair({ ...inD, criteria: 0 }, 6, { ...inD, criteria: 1 }, 2, 4),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(7).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2, button: 6 },
      { ...inD, criteria: 2, button: 7 },
      { ...inD, criteria: 0 },
      ...fillPair({ ...inD, criteria: 0 }, 10, { ...inD, criteria: 1 }, 2, 2),
      ...fillPair({ ...inD, criteria: 0 }, 2, { ...inD, criteria: 1 }, 2, 2),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2, button: 6 },
      { ...inD, criteria: 2, button: 7 },
      ...Array(7).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(7).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2, button: 6 },
      { ...inD, criteria: 2, button: 7 },
      ...Array(7).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...fillPair({ ...inD, criteria: 0 }, 2, { ...inD, criteria: 1 }, 3, 2),
      ...Array(18).fill({ ...inD, criteria: 0 }),
      ...fillPair({ ...inD, criteria: 0 }, 2, { ...inD, criteria: 1 }, 2, 3),
      { ...inD, criteria: 0 },
      { ...inD, criteria: 2, button: 6 },
      { ...inD, criteria: 2, button: 7 },
      ...Array(7).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(7).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2, button: 6 },
      { ...inD, criteria: 2, button: 7 },
      ...Array(7).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(8).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 3 }),
      ...Array(7).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2, button: 6 },
      { ...inD, criteria: 2, button: 7 },
      ...Array(3).fill({ ...inD, criteria: 0 }),
      ...fillPair({ ...inD, criteria: 1 }, 2, { ...inD, criteria: 0 }, 2, 2),
      ...Array(3).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(3).fill({ ...inD, criteria: 0 }),
      ...fillPair({ ...inD, criteria: 1 }, 2, { ...inD, criteria: 0 }, 2, 2),
      ...Array(3).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2, button: 6 },
      { ...inD, criteria: 2, button: 7 },
      ...Array(3).fill({ ...inD, criteria: 0 }),
      ...fillPair({ ...inD, criteria: 1 }, 2, { ...inD, criteria: 0 }, 2, 3),
      ...fillPair({ ...inD, criteria: 0 }, 2, { ...inD, criteria: 1 }, 3, 2),
      ...fillPair({ ...inD, criteria: 0 }, 6, { ...inD, criteria: 1 }, 2, 2),
    ],
  },
  { // Hole in One 2
    name: "Hole in One 2",
    image: 78,
    critname: ["Monkey", "Mandrill"],
    critweight: [50, 40, 10],
    inputs: [
      { ...inD, criteria: 1 },
      ...Array(9).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 1 },
        1,
        { ...inD, criteria: 0 },
        3,
        3,
      ),
      { ...inD, criteria: 0 },
      ...fillPair(
        { ...inD, criteria: 1 },
        1,
        { ...inD, criteria: 0 },
        2,
        2,
      ),
      { ...inD, criteria: 1 },
      ...fillPair(
        { ...inD, criteria: 1 },
        1,
        { ...inD, criteria: 0 },
        7,
        2,
      ),
      { ...inD, criteria: 0 },
      ...fillPair(
        { ...inD, criteria: 1 },
        1,
        { ...inD, criteria: 0 },
        7,
        2,
      ),
      { ...inD, criteria: 0 },
      { ...inD, criteria: 1 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2 },
      { ...inD, criteria: 0 },
      ...fillPair(
        { ...inD, criteria: 1 },
        1,
        { ...inD, criteria: 0 },
        3,
        2,
      ),
      ...Array(2).fill({ ...inD, criteria: 1 }),
    ],
  },
  { // Super Samurai Slice 2
    name: "Super Samurai Slice 2",
    image: 79,
    critname: ["Normal", "Many", "Boss"],
    critweight: [26, 40, 24, 10],
    inputs: [
      ...Array(21).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 2, button: 6 },
        { ...inD, criteria: 2, button: 7 },
      ]),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...Array(6).fill({ ...inD, criteria: 1 }),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 2, button: 6 },
        { ...inD, criteria: 2, button: 7 },
      ]),
      ...Array(6).fill({ ...inD, criteria: 1 }),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 3, button: 6 },
        { ...inD, criteria: 3, button: 7 },
      ]),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(10).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 2, button: 6 },
        { ...inD, criteria: 2, button: 7 },
      ]),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 2, button: 6 },
        { ...inD, criteria: 2, button: 7 },
      ]),
    ],
  },
  { // Right-Hand Remix
    name: "Right-Hand Remix",
    image: 80,
    critname: ["Main", "Keep", "Aim"],
    critweight: [70, 14, 6, 10],
    inputs: [
      ...Array(17).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 0, square: true },
        { ...inD, criteria: 0, square: true },
      ]),
      ...combo(Array.from({ length: 3 }, () => (
        { ...inD, criteria: 0, square: true }
      ))),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 0, button: 4 },
      { ...inD, criteria: 0, button: 5 },
      ...Array(30).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 1, button: 2 }),
      ...Array(12).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 1, button: 2 },
      ...Array(2).fill({ ...inD, criteria: 2 }),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 0, button: 4 },
      { ...inD, criteria: 0, button: 5 },
      { ...inD, criteria: 0, button: 4 },
      ...Array(5).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 0, button: 6 },
        { ...inD, criteria: 0, button: 7 },
      ]),
      { ...inD, criteria: 0 },
      { ...inD, criteria: 3 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 0, button: 6 },
      { ...inD, criteria: 0, button: 7 },
      ...Array(18).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 0, button: 3 }),
      ...Array(10).fill({ ...inD, criteria: 0 }),
    ],
    separators: [
      { index: 0, img: 39 },
      { index: 13, img: 45 },
      { index: 17, img: 57 },
      { index: 22, img: 21 },
      { index: 30, img: 68 },
      { index: 47, img: 51 },
      { index: 64, img: 27 },
      { index: 75, img: 49 },
      { index: 77, img: 61 },
      { index: 81, img: 35 },
      { index: 84, img: 23 },
      { index: 91, img: 20 },
      { index: 93, img: 69 },
      { index: 98, img: 29 },
      { index: 105, img: 36 },
      { index: 114, img: 32 },
      { index: 118, img: 39 },
    ],
  },
  { // Cosmic Dance
    name: "Cosmic Dance",
    image: 81,
    critname: ["Pose", "Squat", "Punch"],
    critweight: [45, 30, 15, 10],
    inputs: [
      { ...inD, criteria: 0, button: 3 },
      { ...inD, criteria: 2 },
      ...Array(2).fill({ ...inD, criteria: 0, button: 3 }),
      ...fillPair(
        { ...inD, criteria: 1, button: 3 },
        1,
        { ...inD, criteria: 0, button: 3 },
        3,
        2,
      ),
      ...Array(3).fill({ ...inD, criteria: 0, button: 3 }),
      ...Array(4).fill({ ...inD, criteria: 1, button: 3 }),
      ...Array(6).fill({ ...inD, criteria: 0, button: 3 }),
      ...Array(2).fill({ ...inD, criteria: 1, button: 3 }),
      ...Array(2).fill({ ...inD, criteria: 0, button: 3 }),
      { ...inD, criteria: 1, button: 3 },
      { ...inD, criteria: 3 },
      { ...inD, criteria: 0, button: 3 },
      ...fillPair(
        { ...inD, criteria: 0, button: 3 },
        2,
        { ...inD, criteria: 2 },
        1,
        2,
      ),
      { ...inD, criteria: 0, button: 3 },
      { ...inD, criteria: 1, button: 3 },
      { ...inD, criteria: 2 },
    ],
  },
  { // Cosmic Rhythm Rally
    name: "Cosmic Rhythm Rally",
    image: 82,
    critname: ["Normal Swing", "Fast Swing", "Long Swing"],
    critweight: [40, 36, 14, 10],
    inputs: [
      { ...inD, criteria: 2 },
      ...fillPair(
        { ...inD, criteria: 0 },
        3,
        { ...inD, criteria: 1 },
        1,
        2,
      ),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        3,
        { ...inD, criteria: 1 },
        1,
        2,
      ),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        3,
        { ...inD, criteria: 1 },
        1,
        2,
      ),
      ...Array(3).fill({ ...inD, criteria: 2 }),
      ...Array(4).fill({ ...inD, criteria: 1 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        3,
        { ...inD, criteria: 1 },
        1,
        2,
      ),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 2 }),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        3,
        { ...inD, criteria: 1 },
        1,
        2,
      ),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        3,
        { ...inD, criteria: 1 },
        1,
        2,
      ),
      ...Array(3).fill({ ...inD, criteria: 2 }),
      ...Array(4).fill({ ...inD, criteria: 3 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        3,
        { ...inD, criteria: 1 },
        1,
        2,
      ),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2 },
    ],
  },
  { // Working Dough 2
    name: "Working Dough 2",
    image: 83,
    critname: ["Small Ball", "Big Ball"],
    critweight: [45, 40, 15],
    inputs: [
      ...Array(7).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        4,
        { ...inD, criteria: 1, button: 2 },
        1,
        2,
      ),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1, button: 2 }),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 2 },
      ...Array(3).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        2,
        { ...inD, criteria: 1, button: 2 },
        1,
        4,
      ),
      { ...inD, criteria: 1, button: 2 },
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 1, button: 2 },
        1,
        { ...inD, criteria: 0 },
        1,
        3,
      ),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(4).fill({ ...inD, criteria: 1, button: 2 }),
      { ...inD, criteria: 2 },
      ...Array(7).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1, button: 2 },
    ],
    separators: [
      { index: 2 },
      { index: 4 },
      { index: 6 },
      { index: 8 },
      { index: 9 },
      { index: 12 },
      { index: 14 },
      { index: 17 },
      { index: 18 },
      { index: 21 },
      { index: 23 },
      { index: 25 },
      { index: 27 },
      { index: 28 },
      { index: 30 },
      { index: 34 },
      { index: 37 },
      { index: 40 },
      { index: 44 },
      { index: 49 },
      { index: 51 },
      { index: 53 },
      { index: 57 },
      { index: 60 },
      { index: 61 },
      { index: 63 },
      { index: 65 },
    ],
  },
  { // Karate Man Senior
    name: "Karate Man Senior",
    image: 84,
    critname: ["Main", "Kick", "Combo"],
    critweight: [32, 30, 30, 8],
    inputs: [
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...Array(12).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 2, button: 6 },
        { ...inD, criteria: 2, button: 7 },
      ]),
      ...Array(12).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...Array(19).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 2, button: 6 },
        { ...inD, criteria: 2, button: 7 },
      ]),
      { ...inD, criteria: 0 },
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...Array(12).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 2, button: 6 },
        { ...inD, criteria: 2, button: 7 },
      ]),
      ...Array(12).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 3, button: 4, square: true },
        { ...inD, criteria: 3, button: 5, square: true },
      ]),
      ...Array(19).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 2, button: 6 },
        { ...inD, criteria: 2, button: 7 },
      ]),
      { ...inD, criteria: 0 },
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      { ...inD, criteria: 0 },
      ...combo([
        { ...inD, criteria: 2, button: 6 },
        { ...inD, criteria: 2, button: 7 },
      ]),
    ],
  },
  { // Final Remix
    name: "Final Remix",
    image: 85,
    critname: ["Main", "Keep", "Aim", "Repeat"],
    critweight: [60, 14, 8, 8, 10],
    inputs: [
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...combo(Array.from({ length: 2 }, () => (
        { ...inD, criteria: 0, square: true }
      ))),
      { ...inD, criteria: 0 },
      ...combo(Array.from({ length: 2 }, () => (
        { ...inD, criteria: 0, square: true }
      ))),
      { ...inD, criteria: 0 },
      ...combo(Array.from({ length: 2 }, () => (
        { ...inD, criteria: 0, square: true }
      ))),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(4).fill({ ...inD, criteria: 0, multi: 2 }),
      ...Array(9).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 3 },
      { ...inD, criteria: 3, button: 3 },
      { ...inD, criteria: 3 },
      ...Array(3).fill(
        combo([
          { ...inD, criteria: 0, button: 4, square: true },
          { ...inD, criteria: 0, button: 5, square: true },
        ]),
      ).flat(),
      ...Array(16).fill({ ...inD, criteria: 1 }),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 0, multi: 2 }),
      ...Array(3).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 0, button: 4 },
      { ...inD, criteria: 0, button: 5 },
      ...Array(4).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0, button: 4 },
      { ...inD, criteria: 0, button: 5 },
      ...Array(6).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(20).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(17).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 1, button: 3 },
      ...Array(8).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 1, button: 2 },
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 0, button: 3 }),
      ...Array(10).fill({ ...inD, criteria: 0 }),
      ...Array(4).fill({ ...inD, criteria: 0, square: true, button: 3 }),
      ...Array(8).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 0, button: 4 },
      { ...inD, criteria: 0, button: 5 },
      ...Array(12).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 1, button: 6 },
      { ...inD, criteria: 1, button: 7 },
      ...Array(9).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 2 },
      ...Array(11).fill({ ...inD, criteria: 0 }),
      ...Array(15).fill({ ...inD, criteria: 3 }),
      ...Array(9).fill({ ...inD, criteria: 0 }),
      ...Array(4).fill(
        combo([
          { ...inD, criteria: 0, button: 4, square: true },
          { ...inD, criteria: 0, button: 5, square: true },
        ]),
      ).flat(),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 0, button: 6 },
        { ...inD, criteria: 0, button: 7 },
      ]),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 0, button: 6 },
        { ...inD, criteria: 0, button: 7 },
      ]),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...combo(Array.from({ length: 2 }, () => (
        { ...inD, criteria: 0, square: true }
      ))),
      { ...inD, criteria: 0 },
      ...combo(Array.from({ length: 2 }, () => (
        { ...inD, criteria: 0, square: true }
      ))),
      { ...inD, criteria: 0 },
      ...combo(Array.from({ length: 2 }, () => (
        { ...inD, criteria: 0, square: true }
      ))),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...combo(Array.from({ length: 4 }, () => (
        { ...inD, criteria: 0, square: true }
      ))),
      ...combo(Array.from({ length: 2 }, () => (
        { ...inD, criteria: 0, square: true }
      ))),
      { ...inD, criteria: 0 },
      ...combo(Array.from({ length: 4 }, () => (
        { ...inD, criteria: 4, square: true }
      ))),
    ],
    separators: [
      { index: 0, img: 52 },
      { index: 11, img: 15 },
      { index: 16, img: 64 },
      { index: 25, img: 59 },
      { index: 28, img: 47 },
      { index: 34, img: 41 },
      { index: 43, img: 31 },
      { index: 50, img: 65 },
      { index: 54, img: 37 },
      { index: 60, img: 13 },
      { index: 63, img: 50 },
      { index: 67, img: 44 },
      { index: 69, img: 22 },
      { index: 85, img: 55 },
      { index: 101, img: 12 },
      { index: 109, img: 63 },
      { index: 126, img: 71 },
      { index: 130, img: 81 },
      { index: 134, img: 76 },
      { index: 143, img: 105 },
      { index: 147, img: 72 },
      { index: 157, img: 82 },
      { index: 163, img: 77 },
      { index: 180, img: 104 },
      { index: 181, img: 73 },
      { index: 192, img: 83 },
      { index: 207, img: 78 },
      { index: 212, img: 107 },
      { index: 216, img: 74 },
      { index: 224, img: 84 },
      { index: 236, img: 79 },
      { index: 244, img: 108 },
      { index: 248, img: 52 },
    ],
  },
  { // Bouncy Road
    name: "Bouncy Road",
    image: 86,
    critname: ["Single Ball", "Double Ball"],
    critweight: [40, 50, 10],
    inputs: [
      ...combo([
        { ...inD, criteria: 0, button: 1, square: true },
        { ...inD, criteria: 0, button: 3, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 0, button: 1, square: true },
        { ...inD, criteria: 0, button: 3, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 0, button: 1, square: true },
        { ...inD, criteria: 0, button: 3, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 0, button: 1, square: true },
        { ...inD, criteria: 0, button: 3, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 0, button: 1, square: true },
        { ...inD, criteria: 0, button: 3, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 0, button: 1, square: true },
        { ...inD, criteria: 0, button: 3, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 0, button: 1, square: true },
        { ...inD, criteria: 0, button: 3, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 2, button: 1, square: true },
        { ...inD, criteria: 2, button: 3, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 1, button: 1, square: true },
        { ...inD, criteria: 1, button: 3, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 1, button: 1, square: true },
        { ...inD, criteria: 1, button: 3, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 1, button: 1, square: true },
        { ...inD, criteria: 1, button: 3, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 1, button: 1, square: true },
        { ...inD, criteria: 1, button: 3, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 1, button: 1, square: true },
        { ...inD, criteria: 1, button: 3, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 1, button: 1, square: true },
        { ...inD, criteria: 1, button: 3, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 1, button: 1, square: true },
        { ...inD, criteria: 1, button: 3, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 0, button: 1, square: true },
        { ...inD, criteria: 0, button: 3, square: true },
      ]),
    ],
  },
  { // The Dazzles
    name: "The Dazzles",
    image: 89,
    critname: ["Main", "Special"],
    critweight: [50, 36, 14],
    inputs: [
      ...fillPair(
        { ...inD, criteria: 0, button: 4 },
        1,
        { ...inD, criteria: 0, button: 5 },
        1,
        4,
      ),
      { ...inD, criteria: 1, button: 4 },
      { ...inD, criteria: 1, button: 5 },
      ...fillPair(
        { ...inD, criteria: 0, button: 4 },
        1,
        { ...inD, criteria: 0, button: 5 },
        1,
        3,
      ),
      { ...inD, criteria: 1, button: 4 },
      { ...inD, criteria: 1, button: 5 },
      ...fillPair(
        { ...inD, criteria: 0, button: 4 },
        1,
        { ...inD, criteria: 0, button: 5 },
        1,
        3,
      ),
      { ...inD, criteria: 2, button: 4 },
      { ...inD, criteria: 2, button: 5 },
      ...fillPair(
        { ...inD, criteria: 0, button: 4 },
        1,
        { ...inD, criteria: 0, button: 5 },
        1,
        4,
      ),
      { ...inD, criteria: 1, button: 4 },
      { ...inD, criteria: 1, button: 5 },
      ...fillPair(
        { ...inD, criteria: 0, button: 4 },
        1,
        { ...inD, criteria: 0, button: 5 },
        1,
        3,
      ),
      { ...inD, criteria: 1, button: 4 },
      { ...inD, criteria: 1, button: 5 },
    ],
  },
  { // Big Rock Finish
    name: "Big Rock Finish",
    image: 90,
    critname: ["Normal", "Fast"],
    critweight: [40, 40, 20],
    inputs: [
      ...Array(8).fill({ ...inD, criteria: 0 }),
      ...Array(4).fill({ ...inD, criteria: 1 }),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(4).fill({ ...inD, criteria: 2 }),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(8).fill({ ...inD, criteria: 1 }),
    ],
    separators: [
      { index: 0, msg: "A" },
      { index: 4, msg: "B" },
      { index: 8, msg: "C" },
      { index: 12, msg: "D" },
      { index: 16, msg: "E" },
      { index: 20, msg: "F" },
      { index: 24, msg: "G" },
      { index: 28, msg: "H" },
    ],
  },
  { // Karate Man Kicks!
    name: "Karate Man Kicks!",
    image: 91,
    critname: ["Single Punch", "Triple Punch", "Kick"],
    critweight: [35, 15, 40, 10],
    inputs: [
      ...combo([
        { ...inD, criteria: 2, button: 4, square: true },
        { ...inD, criteria: 2, button: 5, square: true },
      ]),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 2, button: 4, square: true },
        { ...inD, criteria: 2, button: 5, square: true },
      ]),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 2, button: 4, square: true },
        { ...inD, criteria: 2, button: 5, square: true },
      ]),
      ...Array(14).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 2, button: 4, square: true },
        { ...inD, criteria: 2, button: 5, square: true },
      ]),
      ...Array(14).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 2, button: 4, square: true },
        { ...inD, criteria: 2, button: 5, square: true },
      ]),
      ...Array(11).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 3, button: 4, square: true },
        { ...inD, criteria: 3, button: 5, square: true },
      ]),
      ...Array(3).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(10).fill({ ...inD, criteria: 0 }),
      ...fillPair({ ...inD, criteria: 1 }, 3, { ...inD, criteria: 0 }, 2, 2),
      ...Array(7).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 2, button: 4, square: true },
        { ...inD, criteria: 2, button: 5, square: true },
      ]),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 2, button: 4, square: true },
        { ...inD, criteria: 2, button: 5, square: true },
      ]),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 2, button: 4, square: true },
        { ...inD, criteria: 2, button: 5, square: true },
      ]),
      ...Array(3).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 2, button: 4, square: true },
        { ...inD, criteria: 2, button: 5, square: true },
      ]),
      ...Array(3).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 2, button: 4, square: true },
        { ...inD, criteria: 2, button: 5, square: true },
      ]),
      { ...inD, criteria: 0 },
      ...combo([
        { ...inD, criteria: 2, button: 4, square: true },
        { ...inD, criteria: 2, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 2, button: 4, square: true },
        { ...inD, criteria: 2, button: 5, square: true },
      ]),
      { ...inD, criteria: 0 },
    ],
  },
  { // Built to Scale
    name: "Built to Scale",
    image: 92,
    critname: ["Bounce Rod", "Shoot Rod"],
    critweight: [40, 50, 10],
    inputs: [
      { ...inD, criteria: 0, combo: true, combotype: 1, square: true },
      { ...inD, criteria: 0, combo: true, combotype: 0, square: true },
      {
        ...inD,
        criteria: 1,
        combo: true,
        combotype: 2,
        button: 2,
        square: true,
      },
      { ...inD, criteria: 0, combo: true, combotype: 1, square: true },
      {
        ...inD,
        criteria: 1,
        combo: true,
        combotype: 2,
        button: 2,
        square: true,
      },
      { ...inD, criteria: 0, combo: true, combotype: 1, square: true },
      { ...inD, criteria: 0, combo: true, combotype: 0, square: true },
      {
        ...inD,
        criteria: 1,
        combo: true,
        combotype: 2,
        button: 2,
        square: true,
      },
      { ...inD, criteria: 0, combo: true, combotype: 1, square: true },
      {
        ...inD,
        criteria: 1,
        combo: true,
        combotype: 2,
        button: 2,
        square: true,
      },
      { ...inD, criteria: 0, combo: true, combotype: 1, square: true },
      { ...inD, criteria: 0, combo: true, combotype: 0, square: true },
      {
        ...inD,
        criteria: 1,
        combo: true,
        combotype: 2,
        button: 2,
        square: true,
      },
      { ...inD, criteria: 0, combo: true, combotype: 1, square: true },
      {
        ...inD,
        criteria: 1,
        combo: true,
        combotype: 2,
        button: 2,
        square: true,
      },
      { ...inD, criteria: 0, combo: true, combotype: 1, square: true },
      { ...inD, criteria: 0, combo: true, combotype: 0, square: true },
      {
        ...inD,
        criteria: 1,
        combo: true,
        combotype: 2,
        button: 2,
        square: true,
      },
      { ...inD, criteria: 2, combo: true, combotype: 1, square: true },
      {
        ...inD,
        criteria: 2,
        combo: true,
        combotype: 2,
        button: 2,
        square: true,
      },
      { ...inD, criteria: 0, combo: true, combotype: 1, square: true },
      { ...inD, criteria: 0, combo: true, combotype: 0, square: true },
      {
        ...inD,
        criteria: 1,
        combo: true,
        combotype: 2,
        button: 2,
        square: true,
      },
      { ...inD, criteria: 0, combo: true, combotype: 1, square: true },
      {
        ...inD,
        criteria: 1,
        combo: true,
        combotype: 2,
        button: 2,
        square: true,
      },
      { ...inD, criteria: 0, combo: true, combotype: 1, square: true },
      { ...inD, criteria: 0, combo: true, combotype: 0, square: true },
      {
        ...inD,
        criteria: 1,
        combo: true,
        combotype: 2,
        button: 2,
        square: true,
      },
      { ...inD, criteria: 0, combo: true, combotype: 1, square: true },
      {
        ...inD,
        criteria: 1,
        combo: true,
        combotype: 2,
        button: 2,
        square: true,
      },
      { ...inD, criteria: 0, combo: true, combotype: 1, square: true },
      { ...inD, criteria: 0, combo: true, combotype: 0, square: true },
      {
        ...inD,
        criteria: 1,
        combo: true,
        combotype: 2,
        button: 2,
        square: true,
      },
      { ...inD, criteria: 0, combo: true, combotype: 1, square: true },
      {
        ...inD,
        criteria: 1,
        combo: true,
        combotype: 2,
        button: 2,
        square: true,
      },
      { ...inD, criteria: 0, combo: true, combotype: 1, square: true },
      { ...inD, criteria: 0, combo: true, combotype: 0, square: true },
      {
        ...inD,
        criteria: 1,
        combo: true,
        combotype: 2,
        button: 2,
        square: true,
      },
      { ...inD, criteria: 0, combo: true, combotype: 1, square: true },
      {
        ...inD,
        criteria: 1,
        combo: true,
        combotype: 2,
        button: 2,
        square: true,
      },
    ],
  },
  { // Double Date
    name: "Double Date",
    image: 93,
    critname: ["Soccer Ball", "Basketball", "Rugby Ball"],
    critweight: [40, 30, 22, 8],
    inputs: [
      ...Array(3).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2 },
      ...fillPair(
        { ...inD, criteria: 0 },
        3,
        { ...inD, criteria: 1 },
        1,
        2,
      ),
      { ...inD, criteria: 0 },
      { ...inD, criteria: 1 },
      { ...inD, criteria: 0 },
      { ...inD, criteria: 2 },
      { ...inD, criteria: 0 },
      { ...inD, criteria: 1 },
      { ...inD, criteria: 2 },
      { ...inD, criteria: 0 },
      { ...inD, criteria: 1 },
      { ...inD, criteria: 0 },
      { ...inD, criteria: 2 },
      { ...inD, criteria: 0 },
      { ...inD, criteria: 1 },
      { ...inD, criteria: 3 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
      ...Array(3).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
      ...Array(3).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...Array(3).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2 },
      ...Array(3).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2 },
    ],
  },
  { // Catch of the Day
    name: "Catch of the Day",
    image: 94,
    critname: ["Quicknibble", "Pausegill", "Threefish"],
    critweight: [45, 20, 20, 15],
    inputs: [
      ...Array(3).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
      { ...inD, criteria: 0 },
      ...fillPair(
        { ...inD, criteria: 0 },
        6,
        { ...inD, criteria: 2 },
        1,
        2,
      ),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0 },
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(3).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
      { ...inD, criteria: 2 },
      { ...inD, criteria: 0 },
      { ...inD, criteria: 1 },
      { ...inD, criteria: 3 },
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 2 },
    ],
  },
  { // Fork Lifter
    name: "Fork Lifter",
    image: 95,
    critname: ["Main", "Fast"],
    critweight: [40, 45, 15],
    inputs: [
      ...Array(8).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        2,
        { ...inD, criteria: 1 },
        2,
        2,
      ),
      ...fillPair(
        { ...inD, criteria: 0 },
        5,
        { ...inD, criteria: 1 },
        2,
        2,
      ),
      { ...inD, criteria: 1 },
      ...Array(16).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        1,
        { ...inD, criteria: 1 },
        2,
        4,
      ),
      ...Array(3).fill({ ...inD, criteria: 2 }),
      ...fillPair(
        { ...inD, criteria: 1 },
        2,
        { ...inD, criteria: 0 },
        1,
        2,
      ),
      ...Array(4).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
    ],
  },
  { // Love Rap
    name: "Love Rap",
    image: 96,
    critname: ["Main", "All about you!", "Fo' sho'!"],
    critweight: [30, 30, 30, 10],
    inputs: [
      ...Array(14).fill({ ...inD, criteria: 0 }),
      ...Array(6).fill({ ...inD, criteria: 1 }),
      ...Array(4).fill({ ...inD, criteria: 2 }),
      { ...inD, criteria: 0 },
      ...Array(3).fill({ ...inD, criteria: 2 }),
      { ...inD, criteria: 3 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
    ],
  },
  { // Bossa Nova
    name: "Bossa Nova",
    image: 97,
    critname: ["Main", "Turn"],
    critweight: [35, 55, 10],
    inputs: [
      ...Array(3).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        2,
        { ...inD, criteria: 1 },
        2,
        2,
      ),
      { ...inD, criteria: 1 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        2,
        { ...inD, criteria: 1 },
        2,
        2,
      ),
      { ...inD, criteria: 1 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        2,
        { ...inD, criteria: 1 },
        2,
        2,
      ),
      { ...inD, criteria: 1 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        2,
        { ...inD, criteria: 1 },
        2,
        2,
      ),
      ...fillPair(
        { ...inD, criteria: 1 },
        3,
        { ...inD, criteria: 0 },
        2,
        2,
      ),
      ...fillPair(
        { ...inD, criteria: 0 },
        2,
        { ...inD, criteria: 1 },
        2,
        2,
      ),
      { ...inD, criteria: 1 },
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        2,
        { ...inD, criteria: 1 },
        2,
        2,
      ),
      { ...inD, criteria: 1 },
      ...fillPair(
        { ...inD, criteria: 0 },
        4,
        { ...inD, criteria: 1 },
        2,
        2,
      ),
      ...Array(13).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(7).fill({ ...inD, criteria: 1 }),
      ...fillPair(
        { ...inD, criteria: 1 },
        5,
        { ...inD, criteria: 0 },
        2,
        2,
      ),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(2).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 2 }),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        2,
        { ...inD, criteria: 1 },
        2,
        2,
      ),
      { ...inD, criteria: 1 },
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(2).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0 },
    ],
    separators: [
      { index: 48 },
      { index: 90 },
      { index: 154 },
    ],
  },
  { // Screwbot Factory
    name: "Screwbot Factory",
    image: 98,
    critname: ["Big", "Small"],
    critweight: [46, 46, 8],
    inputs: [
      ...Array(7).fill(
        combo([
          { ...inD, criteria: 0, button: 4, square: true },
          { ...inD, criteria: 0, button: 5, square: true },
        ]),
      ).flat(),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...Array(3).fill(
        combo([
          { ...inD, criteria: 0, button: 4, square: true },
          { ...inD, criteria: 0, button: 5, square: true },
        ]),
      ).flat(),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 2, button: 4, square: true },
        { ...inD, criteria: 2, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
      ...Array(2).fill(
        combo([
          { ...inD, criteria: 1, button: 4, square: true },
          { ...inD, criteria: 1, button: 5, square: true },
        ]),
      ).flat(),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 0, button: 4, square: true },
        { ...inD, criteria: 0, button: 5, square: true },
      ]),
      ...combo([
        { ...inD, criteria: 1, button: 4, square: true },
        { ...inD, criteria: 1, button: 5, square: true },
      ]),
      ...Array(4).fill(
        combo([
          { ...inD, criteria: 0, button: 4, square: true },
          { ...inD, criteria: 0, button: 5, square: true },
        ]),
      ).flat(),
      ...Array(2).fill(
        combo([
          { ...inD, criteria: 1, button: 4, square: true },
          { ...inD, criteria: 1, button: 5, square: true },
        ]),
      ).flat(),
    ],
  },
  { // Board Meeting
    name: "Board Meeting",
    image: 99,
    critname: ["Single", "All"],
    critweight: [56, 30, 14],
    inputs: [
      { ...inD, criteria: 1 },
      ...Array(6).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
      { ...inD, criteria: 2 },
      ...Array(5).fill({ ...inD, criteria: 0 }),
      { ...inD, criteria: 1 },
    ],
  },
  { // Samurai Slice
    name: "Samurai Slice",
    image: 100,
    critname: ["Slice", "Whirlwind Slice"],
    critweight: [50, 35, 15],
    inputs: [
      ...combo([
        { ...inD, criteria: 1, button: 6 },
        { ...inD, criteria: 1, button: 7 },
      ]),
      ...Array(27).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 2, button: 6 },
        { ...inD, criteria: 2, button: 7 },
      ]),
      ...Array(26).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 1, button: 6 },
        { ...inD, criteria: 1, button: 7 },
      ]),
      ...Array(5).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 1, button: 6 },
        { ...inD, criteria: 1, button: 7 },
      ]),
      ...Array(2).fill({ ...inD, criteria: 0 }),
    ],
    separators: [
      { index: 10 },
      { index: 31 },
      { index: 53 },
    ],
  },
  { // Packing Pests
    name: "Packing Pests",
    image: 101,
    critname: ["Main", "Double Up"],
    critweight: [35, 55, 10],
    inputs: [
      ...fillPair(
        { ...inD, criteria: 0, button: 2 },
        1,
        { ...inD, criteria: 0 },
        1,
        3,
      ),
      { ...inD, criteria: 1, button: 2 },
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...fillPair(
        { ...inD, criteria: 0, button: 2 },
        1,
        { ...inD, criteria: 0 },
        1,
        3,
      ),
      { ...inD, criteria: 1, button: 2 },
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...fillPair(
        { ...inD, criteria: 0, button: 2 },
        1,
        { ...inD, criteria: 0 },
        1,
        3,
      ),
      { ...inD, criteria: 1, button: 2 },
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...fillPair(
        { ...inD, criteria: 0, button: 2 },
        1,
        { ...inD, criteria: 0 },
        1,
        3,
      ),
      { ...inD, criteria: 1, button: 2 },
      ...Array(2).fill({ ...inD, criteria: 1 }),
      ...fillPair(
        { ...inD, criteria: 0, button: 2 },
        1,
        { ...inD, criteria: 0 },
        1,
        2,
      ),
      ...fillPair(
        { ...inD, criteria: 1, button: 2 },
        1,
        { ...inD, criteria: 1 },
        2,
        2,
      ),
      ...fillPair(
        { ...inD, criteria: 0, button: 2 },
        1,
        { ...inD, criteria: 0 },
        1,
        2,
      ),
      ...fillPair(
        { ...inD, criteria: 1, button: 2 },
        1,
        { ...inD, criteria: 1 },
        2,
        3,
      ),
      { ...inD, criteria: 0, button: 2 },
      { ...inD, criteria: 0 },
      { ...inD, criteria: 1, button: 2 },
      ...Array(2).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0, button: 2 },
      { ...inD, criteria: 0 },
      { ...inD, criteria: 1, button: 2 },
      ...Array(2).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0, button: 2 },
      { ...inD, criteria: 0 },
      { ...inD, criteria: 1, button: 2 },
      ...Array(2).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0, button: 2 },
      { ...inD, criteria: 0 },
      { ...inD, criteria: 1, button: 2 },
      ...Array(2).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0, button: 2 },
      { ...inD, criteria: 0 },
      { ...inD, criteria: 1, button: 2 },
      ...Array(2).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0, button: 2 },
      { ...inD, criteria: 0 },
      { ...inD, criteria: 1, button: 2 },
      ...Array(2).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0, button: 2 },
      { ...inD, criteria: 0 },
      ...fillPair(
        { ...inD, criteria: 1, button: 2 },
        1,
        { ...inD, criteria: 1 },
        2,
        2,
      ),
      { ...inD, criteria: 2, button: 2 },
    ],
  },
  { // Monkey Watch
    name: "Monkey Watch",
    image: 102,
    critname: ["High-five", "Ooki oo!"],
    critweight: [50, 40, 10],
    inputs: [
      ...fillPair(
        { ...inD, criteria: 0 },
        7,
        { ...inD, criteria: 1 },
        2,
        4,
      ),
      ...fillPair(
        { ...inD, criteria: 0 },
        3,
        { ...inD, criteria: 1 },
        2,
        7,
      ),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        3,
        { ...inD, criteria: 1 },
        2,
        4,
      ),
      { ...inD, criteria: 0 },
      ...Array(2).fill({ ...inD, criteria: 1 }),
      { ...inD, criteria: 0 },
      ...Array(2).fill({ ...inD, criteria: 2 }),
      ...fillPair(
        { ...inD, criteria: 0 },
        7,
        { ...inD, criteria: 1 },
        2,
        4,
      ),
      ...Array(12).fill({ ...inD, criteria: 0 }),
    ],
    separators: [
      { index: 80 },
      { index: 101 },
    ],
  },
  { // Karate Man Combos!
    name: "Karate Man Combos!",
    image: 103,
    critname: ["Single Punch", "Triple Punch", "Combo"],
    critweight: [30, 30, 30, 10],
    inputs: [
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(22).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 2, button: 6 },
        { ...inD, criteria: 2, button: 7 },
      ]),
      ...Array(22).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 2, button: 6 },
        { ...inD, criteria: 2, button: 7 },
      ]),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 2, button: 6 },
        { ...inD, criteria: 2, button: 7 },
      ]),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 3, button: 6 },
        { ...inD, criteria: 3, button: 7 },
      ]),
      ...Array(13).fill({ ...inD, criteria: 0 }),
      ...Array(3).fill({ ...inD, criteria: 1 }),
      ...Array(6).fill({ ...inD, criteria: 0 }),
      ...combo([
        { ...inD, criteria: 2, button: 6 },
        { ...inD, criteria: 2, button: 7 },
      ]),
      ...Array(4).fill({ ...inD, criteria: 0 }),
      ...Array(6).fill({ ...inD, criteria: 1 }),
      ...Array(28).fill({ ...inD, criteria: 0 }),
      ...Array(6).fill({ ...inD, criteria: 1 }),
      ...Array(14).fill({ ...inD, criteria: 0 }),
      ...fillPair({ ...inD, criteria: 1 }, 3, { ...inD, criteria: 0 }, 2, 2),
      ...combo([
        { ...inD, criteria: 2, button: 6 },
        { ...inD, criteria: 2, button: 7 },
      ]),
    ],
  },
];

export interface EL {
  main: number[];
  hold?: number[];
  release?: number[];
  type?: number;
}

export const timingData: EL[] = [
  { main: [56, 34, 38] }, // Karate Man
  { main: [55, 32, 37], release: [51, 25, 33], type: 1 }, // Fillbots
  { main: [57, 34, 37] }, // Air Rally
  { main: [57, 39, 42] }, // Catchy Tune
  { main: [57, 37, 39] }, // Rhythm Tweezers
  { main: [51, 22, 31] }, // Glee Club
  { main: [58, 38, 39] }, // Figure Fighter
  { main: [57, 39, 42] }, // Fruit Basket
  { main: [58, 42, 43] }, // The Clappy Trio
  { main: [58, 39, 40] }, // Shoot-'em-up
  { main: [58, 37, 38] }, // Micro-Row
  { main: [58, 42, 43] }, // First Contact
  { main: [58, 42, 43] }, // Bunny Hop
  { main: [57, 37, 39], release: [58, 44, 45] }, // Airboarder
  { main: [58, 42, 43] }, // Exhibition Match
  { main: [56, 37, 40] }, // Tongue Lashing
  { main: [56, 37, 40] }, // Sneaky Spirits
  { main: [55, 34, 38] }, // Rhythm Rally
  { main: [56, 37, 40] }, // Flipper-Flop
  { main: [25, -10, 1], type: 8 }, // LumBEARjack
  { main: [18, -25, -12] }, // Power Calligraphy
  { main: [58, 42, 43] }, // Blue Birds
  { main: [], type: 2 }, // Flock Step
  { main: [57, 39, 42], type: 3 }, // Super Samurai Slice
  { main: [58, 42, 43] }, // Spaceball
  { main: [57, 44, 46] }, // Dog Ninja
  { main: [58, 42, 43] }, // Hole in One
  { main: [57, 39, 42] }, // Sumo Brothers
  { main: [] }, // Lush Remix
  { main: [56, 34, 38] }, // Karate Man Returns!
  { main: [55, 32, 37], release: [51, 25, 33], type: 1 }, // Fillbots 2
  { main: [57, 34, 37] }, // Air Rally 2
  { main: [57, 39, 42] }, // Catchy Tune 2
  { main: [] }, // Honeybee Remix
  { main: [57, 37, 39], type: 4 }, // Rhythm Tweezers 2
  { main: [51, 22, 31] }, // Glee Club 2
  { main: [58, 38, 39] }, // Figure Fighter 2
  { main: [57, 39, 42] }, // Fruit Basket 2
  { main: [] }, // Machine Remix
  { main: [58, 42, 43] }, // The Clappy Trio 2
  { main: [58, 39, 40] }, // Shoot-'em-up 2
  { main: [58, 37, 38] }, // Micro-Row 2
  { main: [58, 42, 43] }, // Second Contact
  { main: [] }, // Citrus Remix
  { main: [58, 42, 43], release: [57, 37, 38] }, // Rat Race
  { main: [58, 42, 43], type: 5 }, // Fan Club
  { main: [58, 42, 43] }, // Working Dough
  { main: [58, 42, 43] }, // Animal Acrobat
  { main: [] }, // Donut Remix
  { main: [56, 37, 40] }, // Sneaky Spirits 2
  { main: [55, 34, 38] }, // Rhythm Rally 2
  { main: [56, 37, 40] }, // Flipper-Flop 2
  { main: [25, -10, 1], type: 8 }, // LumBEARjack 2
  { main: [] }, // Barbershop Remix
  { main: [56, 37, 40] }, // Tap Trial
  { main: [57, 34, 37] }, // Frog Hop
  { main: [57, 39, 42] }, // Ringside
  { main: [57, 39, 42] }, // Tangotronic 3000
  { main: [] }, // Songbird Remix
  { main: [58, 42, 43] }, // Ninja Bodyguard
  { main: [56, 37, 40] }, // Freeze Frame
  { main: [58, 42, 43] }, // Launch Party
  { main: [58, 42, 43], hold: [57, 37, 39], release: [57, 37, 39] }, // Pajama Party
  { main: [58, 42, 43] }, // Marching Orders
  { main: [55, 32, 37] }, // Munchy Monk
  { main: [57, 39, 42] }, // See-Saw
  { main: [58, 42, 43] }, // Blue Bear
  { main: [58, 42, 43] }, // Space Dance
  { main: [58, 44, 45] }, // Lockstep
  { main: [58, 42, 43], type: 6 }, // Cheer Readers
  { main: [58, 42, 43], type: 3 }, // Kitties!
  { main: [58, 42, 43] }, // The Snappy Trio
  { main: [58, 42, 43], type: 5 }, // Fan Club 2
  { main: [58, 38, 39] }, // Figure Fighter 3
  { main: [58, 42, 43] }, // Jungle Gymnast
  { main: [] }, // Left-Hand Remix
  { main: [56, 37, 40] }, // Tap Trial 2
  { main: [57, 34, 37] }, // Jumpin' Jazz
  { main: [58, 42, 43] }, // Hole in One 2
  { main: [57, 39, 42], type: 3 }, // Super Samurai Slice 2
  { main: [] }, // Right-Hand Remix
  { main: [58, 42, 43] }, // Cosmic Dance
  { main: [55, 34, 38] }, // Cosmic Rhythm Rally
  { main: [58, 42, 43] }, // Working Dough 2
  { main: [56, 34, 38], release: [56, 30, 33], type: 1 }, // Karate Man Senior
  { main: [] }, // Final Remix
  { main: [], type: 2 }, // Bouncy Road
  { main: [] }, // Night Walk
  { main: [] }, // Quiz Show
  { main: [58, 44, 45], release: [57, 39, 42] }, // The Dazzles
  { main: [54, 32, 38] }, // Big Rock Finish
  { main: [56, 34, 38], release: [56, 30, 33], type: 1 }, // Karate Man Kicks!
  { main: [58, 44, 45] }, // Built to Scale
  { main: [57, 44, 46] }, // Double Date
  { main: [56, 37, 40] }, // Catch of the Day
  { main: [58, 44, 45] }, // Fork Lifter
  { main: [56, 42, 45] }, // Love Rap
  { main: [57, 42, 42] }, // Bossa Nova
  { main: [55, 37, 42] }, // Screwbot Factory
  { main: [58, 37, 38] }, // Board Meeting
  { main: [58, 46, 48], hold: [58, 42, 43], type: 7 }, // Samurai Slice
  { main: [58, 39, 40] }, // Packing Pests
  { main: [57, 30, 32] }, // Monkey Watch
  { main: [56, 34, 38], release: [56, 30, 33] }, // Karate Man Combos!
  { main: [], type: 2 }, // Coin Toss
  { main: [58, 42, 43] }, // Sick Beats
  { main: [] }, // Charging Chicken
  { main: [57, 44, 46] }, // Clap Trap
  { main: [56, 42, 45] }, // Tutorial
];
